import React from "react";
// import HttpService from '../../utils/Http.services';
import { siteConfig, siteTheme } from "../../variables/config";
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import * as actions from '../../stores/actionsList';
// import TabBar from "../views/TabBar";
import Configurer from "../../components/Configurer";
import ProfileImage from "../../components/partials/ProfileImage";
import TableViewer from "../../components/TableViewer";
// import { v4 as uuidv4 } from 'uuid';
import ItemModal from "../../modals/ItemModal";
import ConvertModal from "../../modals/ItemModal";
import HttpServices from "../../utils/Http.services";
import RemoveModal from "../../modals/RemoveModal";
import { checkPermission, checkTextTranslation, checkTranslation, pathMaker, phoneStandardView } from "../../utils/useful";
import FilterModal from "../../modals/FilterModal";
import ImportModal from "../../modals/ImportModal";
import Pagination from "../../components/Pagination";
import OptionsListModal from "../../modals/OptionsListModal";
import Loader from 'react-loader-spinner'
import Modal from "../../components/Modal";
import { saveAs } from 'file-saver';
import FileSaver from 'file-saver';
import * as XLSX from "xlsx";
// import { adminPages } from "../../variables/adminPages";
import FormViewer from "../../components/FormViewer";
import DateInput from "../../components/inputs/DateInput";
import moment from 'jalali-moment'
import SelectInput from "../../components/inputs/SelectInput";
import NumberInput from "../../components/inputs/NumberInput";
import AdvancedSelectInput from "../../components/inputs/AdvancedSelectInput";
import GridViewer from "../../components/GridViewer";
import LegacyContentWorkspaceChoices from "../../components/LegacyContentWorkspaceChoices";
import RealmDuplicateAccountReview from "../../components/RealmDuplicateAccountReview";



class AdminFormApplet extends React.Component {


    openEditModal = (prop, index) => {
        // console.log(prop)
        // this.itemModal.open()
        // this.setState({ currentItem: prop, currentIndex: index })
        if (this.props.page?.addNew && this.props.page?.addNew != -1) {

            if (this.props.page?.addNew?.function) {
                if (this[this.props.page?.addNew?.function]) {
                    this[this.props.page?.addNew?.function]()
                }

            } else if (this.props.page?.addNew?.page) {
                let newPage = this.props.route + this.props.page?.addNew.page
                this.props.history.push(pathMaker(newPage + '?id=' + prop._id + '&ref=' + pathMaker(this.props.route + '/' + this.props.page?.key)))
            }
            else {
                let newPage = this.props.page?.addNew
                if (this.props.page?.addNew?.includes('../')) {
                    newPage = this.props.route + this.props.page?.addNew.replace('..', '')
                }

                // this.props.history.push({ pathname: pathMaker(newPage), search: '?ref=' + pathMaker('/' + this.props.route + '/' + this.props.page?.key), state: { isAdmin: true } })

                this.props.history.push(pathMaker(newPage + '?id=' + prop._id + '&ref=' + pathMaker(this.props.route + '/' + this.props.page?.key)))
            }
        } else {
            this.itemModal.open()
            this.setState({ currentItem: prop, currentIndex: index })
        }
    }
    openConvertionModal = (prop, index) => {
        // if(this.props.page.key == 'equipments'){

        //     prop.rentalEq = prop._id
        // }else if(this.props.page.key == 'tequipments'){
        //     prop.sellEq = prop._id

        // }
        this.ConvertModal.open()
        // delete prop._id
        delete prop.price
        this.setState({ currentItem: prop, currentIndex: index })
    }

    openRemoveModal = (prop, index) => {
        this.removeModal.modal.showModal()
        this.setState({ currentItem: prop, currentIndex: index })
    }
    openImport = () => {
        this.ImportModal.modal.showModal()
    }

    importAiWebsiteContent = async () => {
        if (this.aiImportRunning) return;
        this.aiImportRunning = true;
        const request = apply => new Promise((resolve, reject) => HttpServices.request('importAiWebsiteContent', { apply }, (result, error) => error ? reject(error) : resolve(result.info)));
        try {
            const preview = await request(false);
            if (!window.confirm(`Import AI website content? ${preview.created} new documents (${preview.plansCreated || 0} subscription plans), ${preview.existing} already imported, ${preview.conflicts.length} conflicts will be skipped. Existing documents and admin edits will stay unchanged.`)) return;
            const result = await request(true);
            this.props.actions.addNotif({ type: 'success', title: 'AI website content imported', description: `${result.created} created; ${result.existing} already imported; ${result.conflicts.length} conflicts skipped.` });
            if (result.conflicts.length) window.alert('Existing slugs were preserved:\n' + result.conflicts.map(item => item.key).join('\n'));
            this.fetchData(true);
        } catch (error) {
            this.props.actions.addNotif({ type: 'error', title: 'Import unavailable', description: error?.message || 'Import did not finish. It is safe to retry.' });
        } finally { this.aiImportRunning = false; }
    }

    importUsdEquipmentDrafts = async () => {
        if (this.equipmentDraftImportRunning) return
        if (!checkPermission('admin.additionalEquipmentPlan.create')) {
            this.props.actions.addNotif({ type: 'error', title: 'Permission denied', description: 'Equipment plan creation permission is required.' })
            return
        }
        this.equipmentDraftImportRunning = true
        const request = body => new Promise((resolve, reject) => HttpServices.request('importAdditionalEquipmentDrafts', body,
            (result, error) => error ? reject(error) : resolve(result?.info)))
        try {
            const preview = await request({ apply: false })
            if (!preview || !Array.isArray(preview.plans)) throw new Error('Could not preview equipment drafts.')
            const missing = preview.plans.filter(plan => plan.status === 'missing')
            if (!missing.length) {
                this.props.actions.addNotif({ type: 'success', title: 'Equipment drafts already present', description: 'No records were changed.' })
                this.fetchData(true)
                return
            }
            const offers = missing.map(plan => `${plan.equipment.toLocaleString()} slots / ${plan.period}: USD ${(plan.usdMinor / 100).toFixed(2)}`).join('\n')
            if (!window.confirm(`Import ${missing.length} inactive USD equipment drafts?\n\n${offers}\n\nExisting plans and prices will not be changed. Review each draft before enabling purchases.`)) return
            const result = await request({ apply: true, confirmation: 'IMPORT_USD_EQUIPMENT_DRAFTS' })
            this.props.actions.addNotif({ type: 'success', title: 'Equipment drafts imported', description: `${result.created} added; ${result.existing} already present. All new offers remain inactive.` })
            this.fetchData(true)
        } catch (error) {
            this.props.actions.addNotif({ type: 'error', title: 'Equipment import failed', description: error?.message || 'No existing plans were changed. Retry after checking the API.' })
        } finally { this.equipmentDraftImportRunning = false }
    }

    loadAiWebsitePublicationPreview = () => {
        const requestId = (this.aiPlanPreviewRequestId || 0) + 1
        this.aiPlanPreviewRequestId = requestId
        clearTimeout(this.aiPlanPreviewTimeout)
        this.setState({ aiPlanPublicationLoading: true, aiPlanPublicationConfirmed: false, aiPlanPublicationPreview: null, aiPlanPublicationError: '' })
        this.aiPlanPreviewTimeout = setTimeout(() => {
            if (this.aiPlanPreviewRequestId !== requestId) return
            this.aiPlanPreviewRequestId++
            this.setState({ aiPlanPublicationLoading: false, aiPlanPublicationError: 'Publication preview timed out. Refresh to retry; no plans were published.' })
        }, 30000)
        const body = this.state.aiPlanPublicationMode ? { stripePaymentMode: this.state.aiPlanPublicationMode } : {}
        HttpServices.request('getAiWebsitePublicationPreview', body, (result, error) => {
            if (this.aiPlanPreviewRequestId !== requestId) return
            clearTimeout(this.aiPlanPreviewTimeout)
            this.setState({
                aiPlanPublicationLoading: false,
                aiPlanPublicationPreview: result?.info || null,
                aiPlanModeSelectionEnabled: result?.info?.modeSelectionEnabled || this.state.aiPlanModeSelectionEnabled,
                aiPlanPublicationError: error?.message || (result?.info ? '' : 'Could not load publication preview.'),
            })
        })
    }

    openAiWebsitePublication = () => {
        if (!checkPermission('admin.subscriptionPlan.edit')) {
            this.props.actions.addNotif({ type: 'error', title: 'Permission denied', description: 'Subscription plan edit permission is required.' })
            return
        }
        this.setState({ aiPlanPublicationConfirmed: false, aiPlanPublicationPreview: null, aiPlanPublicationError: '' }, () => {
            this.aiPlanPublicationModal.showModal()
            this.loadAiWebsitePublicationPreview()
        })
    }

    submitAiWebsitePublication = () => {
        const preview = this.state.aiPlanPublicationPreview
        if (!checkPermission('admin.subscriptionPlan.edit') || !preview?.readyToPublish || preview.run?.status === 'running' || this.state.aiPlanPublicationLoading ||
            !this.state.aiPlanPublicationConfirmed || this.state.aiPlanPublicationSubmitting) return
        this.setState({ aiPlanPublicationSubmitting: true, aiPlanPublicationError: '' })
        HttpServices.request('publishAiWebsitePlans', {
            confirmation: 'PUBLISH_AI_WEBSITE_USD_PLANS',
            commercialVersion: preview.commercialVersion,
            stripeMode: preview.stripeMode,
            ...(this.state.aiPlanPublicationMode ? { stripePaymentMode: this.state.aiPlanPublicationMode } : {}),
        }, (result, error) => {
            this.setState({
                aiPlanPublicationSubmitting: false,
                aiPlanPublicationConfirmed: false,
                aiPlanPublicationPreview: result?.info || preview,
                aiPlanPublicationError: error?.message || '',
            })
            if (result?.info) {
                this.props.actions.addNotif({ type: 'success', title: 'AI website plans published', description: 'Six verified USD plans are now available for checkout.' })
                this.fetchData(true)
            }
        })
    }

    publishSubscriptionPlan = async (plan, mode) => {
        if (this.individualPlanPublicationRunning || !plan?._id) return
        if (!checkPermission('admin.subscriptionPlan.edit')) {
            this.props.actions.addNotif({ type: 'error', title: 'Permission denied', description: 'Subscription plan edit permission is required.' })
            return
        }
        const isLive = mode === 'live'
        const warning = isLive
            ? `Publish "${plan.name}" to LIVE Stripe checkout? Customers can be charged real money after this completes.`
            : `Publish "${plan.name}" to TEST Stripe checkout? This creates or verifies sandbox product and price records.`
        if (!window.confirm(warning)) return
        this.individualPlanPublicationRunning = true
        try {
            const result = await this.requestAsPromise('publishIndividualSubscriptionPlan', {
                id: plan._id,
                stripePaymentMode: mode,
                confirmation: `PUBLISH_INDIVIDUAL_PLAN_${mode.toUpperCase()}`,
            })
            this.props.actions.addNotif({
                type: 'success',
                title: `${mode === 'test' ? 'Test' : 'Live'} checkout published`,
                description: `${result?.info?.name || plan.name} is ready for ${mode} checkout.`,
            })
            this.fetchData(true)
        } catch (error) {
            this.props.actions.addNotif({
                type: 'error',
                title: `${mode === 'test' ? 'Test' : 'Live'} publication failed`,
                description: error?.message || 'The plan was not published. Fix the reported configuration and retry.',
            })
        } finally {
            this.individualPlanPublicationRunning = false
        }
    }

    publishSubscriptionPlanTest = (plan) => this.publishSubscriptionPlan(plan, 'test')
    publishSubscriptionPlanLive = (plan) => this.publishSubscriptionPlan(plan, 'live')

    reviveAiData = async () => {
        if (this.aiReviveRunning) return;
        this.aiReviveRunning = true;
        const request = apply => new Promise((resolve, reject) => HttpServices.request('reviveAiData', { apply }, (result, error) => error ? reject(error) : resolve(result.info)));
        try {
            const preview = await request(false);
            const roles = preview.roles?.length || 0;
            const industries = preview.industries?.length || 0;
            const tutorials = preview.tutorials?.length || 0;
            if (!window.confirm(`Revive AI data? Soft-delete ${preview.matched} database rows (${roles} roles, ${industries} industries, ${tutorials} tutorials) so the AI website uses hardcoded pages instead.`)) return;
            const result = await request(true);
            this.props.actions.addNotif({
                type: 'success',
                title: 'AI data revived',
                description: `Soft-deleted ${result.modified} rows (${result.roles?.length || 0} roles, ${result.industries?.length || 0} industries, ${result.tutorials?.length || 0} tutorials).`,
            });
            this.fetchData(true);
        } catch (error) {
            this.props.actions.addNotif({ type: 'error', title: 'Revive unavailable', description: error?.message || 'Revive AI data did not finish. It is safe to retry.' });
        } finally { this.aiReviveRunning = false; }
    }

    state = {
        extendPrice: '',
        isChecked: true,
        RecivedData: false,
        notAvailable: false,
        data: [],
        fullData: {},
        actions: {
            edit: { key: "edit", label: '{{lang}}edit', color: '#677dc4', function: this.openEditModal, permission: ['view'] },
            remove: { key: "remove", label: '{{lang}}remove', color: '#ee5050', function: this.openRemoveModal, permission: ['delete'] }
        },
        extendTime: '',
        extraItems: [],
        currentPage: 0,
        limit: 20,
        options: [
            // { name: 'Export', icon: '/images/eye.svg', function: this.openExport },
            // { name: 'Edit', icon: '/images/settings.svg', function: this.openEdit },
            // { name: 'Connect', icon: '/images/settings.svg', function: this.fetchConnect },
            // { name: 'Remove', description: 'remove this data', icon: '/images/remove.svg', function: this.openRemoveModal },
        ],
        headers: [
            { type: 'DateInput', key: 'extendTime', showMain: true, information: { label: 'Select Date', required: true, placeholder: ' Select your desired date ', } },

        ],
        aiBillingLoading: false,
        aiBillingSubmitting: false,
        aiBillingLedgerLoadingMore: false,
        aiBillingTenants: [],
        aiBillingTenantId: '',
        aiBillingSummary: null,
        aiBillingLedger: [],
        aiBillingNextCursor: null,
        aiBillingError: '',
        aiGrantCredits: '',
        aiGrantReason: '',
        aiGrantTicketRef: '',
        aiGrantIdempotencyKey: '',
        bulkAiGrantCredits: 100,
        bulkAiGrantReason: '',
        bulkAiGrantTicketRef: '',
        bulkAiGrantBatchId: '',
        bulkAiGrantConfirmed: false,
        bulkAiGrantSubmitting: false,
        bulkAiGrantResult: null,
        bulkAiGrantError: '',
        postDeployMigrationStatus: null,
        postDeployMigrationError: '',
        postDeployMigrationConfirmed: false,
        postDeploySearchAliasConfirmed: false,
        postDeployMigrationWorkerStopped: false,
        postDeployMigrationSubmitting: false,
        postDeployContentChoices: [],
        postDeployContentTargets: {},
        postDeployContentLoading: false,
        postDeployContentError: '',
        postDeployRealmReview: null,
        postDeployRealmReviewLoading: false,
        postDeployRealmReviewError: '',
        storefrontRouteLoading: false,
        storefrontRoutePreview: null,
        storefrontRouteConfirmed: false,
        storefrontRouteSubmitting: false,
        storefrontRouteError: '',
        aiPlanPublicationLoading: false,
        aiPlanPublicationMode: null,
        aiPlanModeSelectionEnabled: false,
        aiPlanPublicationPreview: null,
        aiPlanPublicationConfirmed: false,
        aiPlanPublicationSubmitting: false,
        aiPlanPublicationError: ''
    }


    componentDidMount() {
        this.init()
    }

    componentWillUnmount() {
        this.stopPostDeployMigrationPolling()
        this.aiPlanPreviewRequestId = (this.aiPlanPreviewRequestId || 0) + 1
        clearTimeout(this.aiPlanPreviewTimeout)
    }

    componentDidUpdate(prevProps) {
        if (this.props.page !== prevProps.page) {
            // setTimeout(() => {
            this.init()
            // }, 500);
        }
    }


    init() {
        if (this.props.page) {
            this.setState({ showTable: false, selectedTab: null, data: [], totalCount: null, filters: null, filter: {}, filter2: {} }, () => {
                this.fetchData(true)
            })
        }
    }

    fetchData = (getCount) => {

        this.setState({ isLoadingData: true, hideForm: true })
        let body = this.props.page.filter ?? {}
        let page = this.props.page
        body.page = page.key
        body.limit = this.state.limit
        body.skip = this.state.currentPage

        // body.active = 0

        // body.filter = this.state.filter ?? {}

        // if (this.props.page.postBody) {
        //     body.filter = { ...body.filter, ...this.props.page.postBody }
        // }

        body.filter = this.state.filter ?? {}

        if (this.props.page.postBody) {
            body.filter = { ...this.props.page.postBody, ...body.filter }
        }

        if (this.state.filter2) {
            body.filter2 = this.state.filter2
        }



        // if (this.props.settings.country) {
        //     body.country = this.props.settings.country
        // }

        if (this.props.page.populate) {
            body.populate = this.props.page.populate
        }

        if (this.props.page.sort) {
            body.sort = this.props.page.sort
        }


        for (const [key, value] of Object.entries(body)) {
            if (/\{\{(.*?)\}\}/.test(value)) {

                if (this.props.variables) {
                    body[key] = this.props.variables[value.replace(/{/g, '').replace(/}/g, '')]
                }
            }
        }

        if (body.filter) {
            for (const [key, value] of Object.entries(body.filter)) {
                if (/\{\{(.*?)\}\}/.test(value)) {

                    if (this.props.variables) {
                        body.filter[key] = this.props.variables[value.replace(/{/g, '').replace(/}/g, '')]
                    }
                }
            }
        }

        if (this.state.totalCount == null || getCount) {
            body.getCount = true
        }
        let country = []
        let countries = this.props.settings.country ?? []
        for (let i = 0; i < countries.length; i++) {
            const element = countries[i];
            country.push(element.iso3)
        }
        if (country.length > 0) {

            body.country = country
        } else {
            body.NoCountry = true
        }
        if (body.filter2 && body.filter2.country) {
            delete body.country
        }
        console.log('subressssss', body)
        // console.log(page.fetchUrl)

        HttpServices.request(page.fetchUrl, body, (fetchResult, fetchError) => {
            this.setState({ isLoadingData: false })
            // console.log(fetchError)
            console.log('ressssss', fetchResult, fetchError)

            if (fetchError) {
                this.props.actions.addNotif({ type: 'error', title: '{{lang}}errors.loadDataFailed', description: fetchError.message })
                return
            }
            // console.log(fetchResult)
            this.setState({ data: [] }, () => {
                this.setState({ data: fetchResult.info, fullData: fetchResult }, () => {
                    this.setState({ showTable: true, hideForm: false })
                })
            })

            if (fetchResult.count != null) {
                this.setState({ totalCount: fetchResult.count })
            }
        })
    }


    openRefModal = (prop, index, reference) => {
        // console.log("openRefModal")
        // console.log(reference)
        let page = this.props.pages[reference.ref]
        if (!page) {
            page = this.props.adminPages[reference.ref]
        }

        let _id = typeof prop == 'object' ? prop._id : prop

        let body = { filter: { _id } }

        if (page?.page) {
            body.filter = { ...{ page: page.key, _id }, ...body.filter }
        }


        console.log(body)
        HttpServices.request(page.fetchOne, body, (fetchResult, fetchError) => {
            if (fetchError) {
                this.props.actions.addNotif({ type: 'error', title: '{{lang}}errors.loadDataFailed', description: fetchError.message })
                return
            }

            let newItem = { page, data: fetchResult.info }
            let extraItems = this.state.extraItems
            extraItems.push(newItem)
            this.setState({ extraItems }, () => {
                setTimeout(() => {
                    this['itemModal' + String(extraItems.length - 1)].modal.showModal()
                }, 10);
            })

        })
        // console.log(object.key)

    }


    changePage = (index) => {
        this.setState({ currentPage: index }, () => {
            this.fetchData()
        })
    }


    fetchRemove = () => {
        this.setState({ isLoadingRemove: true })
        let id = this.state.currentItem._id
        // console.log(id)
        // console.log(this.props.page.removeUrl)
        HttpServices.request(this.props.page.removeUrl, { "id": id, page: this.props.page.page ?? this.props.page.key }, (fetchResult, fetchError) => {
            this.setState({ isLoadingRemove: false })
            // console.log(fetchError)
            if (fetchError) {
                this.props.actions.addNotif({ type: 'error', title: '{{lang}}Remove Failed', description: fetchError.message })
                return
            }
            let data = this.state.data
            data.splice(this.state.currentIndex, 1)
            this.setState({ data })
            this.removeModal.modal.hideModal()
            this.props.actions.addNotif({ type: 'success', title: '{{lang}}Removed', description: '{{lang}}Removed Record Successfully' })


        })

    }



    fetchExport = () => {

        let body = this.props.page.filter ?? {}; let page = this.props.page
        body.page = page.key; body.limit = this.state.limit; body.skip = this.state.currentPage; body.filter = this.state.filter ?? {}
        // body.page = page.key

        if (this.state.filter2) body.filter2 = this.state.filter2

        if (this.props.page.postBody) body.filter = { ...body.filter, ...this.props.page.postBody }

        if (this.props.page.populate) body.populate = this.props.page.populate

        if (this.props.page.sort) body.sort = this.props.page.sort
        let country = []
        let countries = this.props.settings.country
        for (let i = 0; i < countries.length; i++) {
            const element = countries[i];
            country.push(element.iso3)
        }
        if (country.length > 0) {

            body.country = country
        } else {
            delete body.filter.country
            body.NoCountry = true
        }


        // if (this.state.totalCount == null || getCount) body.getCount = true

        body.headers = this.props.page.headers


        HttpServices.request(this.props.page?.extra?.export?.url, body, (fetchResult, fetchError) => {
            // this.setState({ isLoadingRemove: false })
            // console.log(fetchError)
            // console.log(fetchResult)
            if (fetchError) {
                this.props.actions.addNotif({ type: 'error', title: '{{lang}}errors.removeFailed', description: fetchError.message })
                return
            }
            // let data = this.state.data
            // data.splice(this.state.currentIndex, 1)
            // this.setState({ data })
            // console.log(siteConfig.assetsDomain + fetchResult.info)
            setTimeout(() => {
                
                saveAs(siteConfig.assetsDomain + 'images/' + fetchResult.info)
            }, 4000);

            this.exportModal.hideModal()
            this.props.actions.addNotif({ type: 'success', title: '{{lang}}info.removedSuccesfully', description: '{{lang}}info.dataRemovedSuccessfully' })
        })
    }


    itemAdded = (newItem, modalIndex) => {
        // console.log(newItem)

        if (newItem && modalIndex == null) {
            let data = this.state.data
            data.splice(0, 0, newItem)
            // console.log(newItem)
            // console.log(data)
            this.setState(data)
        } else {
            this.fetchData(true)
        }
    }

    itemEdited = (editedItem, id, modalIndex) => {
        // console.log('kkkkkkkkkkkkkkkkeeeeeeeeeeeeee')
        if (modalIndex == null) {
            let data = this.state.data
            this.state.data.forEach((element, index) => {
                let id = element.id ?? element._id
                let currentId = this.state.currentItem.id ?? this.state.currentItem._id
                if (id === currentId) {
                    // console.log(id)
                    data[index] = Object.assign({}, editedItem)
                }
            })
            this.setState({ data }, () => {
                // console.log('kkkk',editedItem)
                // console.log(data)
                // this.TableViewer.forceUpdateData()
            })
        } else {
            this.fetchData()
        }
    }

    updateData = (data) => {
        this.setState(data)
    }


    openAddNew = () => {

        console.log("openAddNew")
        console.log(this.props.page)
        if (this.props.page?.addNew) {
            let newPage = this.props.page?.addNew
            if (this.props.page?.addNew.includes('../')) {
                newPage = this.props.route + this.props.page?.addNew.replace('..', '')
            }
            // console.log(newPage)
            this.props.history.push({ pathname: pathMaker(newPage), search: '?ref=' + pathMaker('/' + this.props.route + '/' + this.props.page?.key), state: { isAdmin: true } })
        } else {
            this.openEditModal()
        }
    }

    openFilterModal() {
        this.filterModal.showModal()
    }

    doFilter = (data) => {
        // console.log(data)
        this.setState({ currentPage: 0, filter2: data }, () => {
            this.fetchData(true)
            this.filterModal.modal.hideModal()

        })
    }

    filterLabelCreator(rawprop) {
        let prop = JSON.parse(JSON.stringify(rawprop))
        // console.log(prop)
        let isArray = false
        if (Array.isArray(prop.value)) {
            isArray = true
        }

        // let label
        let value = prop.value
        if (prop.type == 'PhoneInput') {
            value = phoneStandardView(value)
        }


        if (prop.dictionary) {

            if (Array.isArray(value)) {
                for (let i = 0; i < value.length; i++) {
                    const element = value[i];
                    if (prop.dictionary[element]) {
                        value[i] = prop.dictionary[element]
                    }
                }
            } else {
                if (prop.dictionary[value]) {
                    value = prop.dictionary[value]
                }
            }
        }

        let label = checkTranslation(prop.label) + ' ' + prop.operator + ' ' + value


        return label
    }

    removeFilter = (prop) => {
        let filter2 = this.state.filter2
        delete filter2[prop.key]
        // console.log(filter)
        this.setState({ filter2 }, () => {
            this.fetchData(true)
        })
    }


    openOptions = (prop, index) => {
        // console.log(prop)

        let options = []

        Object.values(this.props.page?.extra).forEach(element => {
            let option = { ...element }
            option.function = this[option.function]
            options.push(option)
        });
        console.log(options)
        // { name: 'Export', icon: '/images/eye.svg', function: this.openExport },
        // { name: 'Edit', icon: '/images/settings.svg', function: this.openEdit },
        // { name: 'Connect', icon: '/images/settings.svg', function: this.fetchConnect },
        // { name: 'Remove', description: 'remove this data', icon: '/images/remove.svg', function: this.openRemoveModal },
        // ]

        this.setState({ options, currentItem: prop, currentIndex: index }, () => {
            this.optionsModal.modal.showModal()
        })


    }

    GetInsurancePdf = (prop, index, reference) => {

        let body = { _id: prop._id }
        // console.log(body)
        this.exportModal.showModal()

        HttpServices.request('GetInsurancePdf', body, (fetchResult, fetchError) => {
            console.log(fetchError)
            if (fetchError) {
                this.props.actions.addNotif({ type: 'error', title: '{{lang}}It Does Not Have Insurance', description: fetchError.message })
                this.exportModal.hideModal()
                return
            }

            console.log(fetchResult)

            this.exportModal.hideModal()

            if (fetchResult.file) {

                // saveAs(siteConfig.assetsDomain + 'assets/pdfs/' + fetchResult.file)
                saveAs(siteConfig.assetsDomain + 'pdfs/' + fetchResult.file)

                this.props.actions.addNotif({ type: 'success', title: '{{lang}}PDF Created Successfuly', description: '{{lang}Pdf Has been Generated successfully' })

                // let url = assetsUrl + 'pdfs/' + data.file
                // window.open(url, '_blank');
                // console.log()
            }

            // saveAs(siteConfig.assetsDomain + fetchResult.info)

            // this.exportModal.hideModal()
        })

    }
    downloadFinancialPDF = (prop, index, reference) => {

        let body = { _id: prop._id }
        // console.log(body)
        this.exportModal.showModal()

        HttpServices.request('getInvoicePDF', body, (fetchResult, fetchError) => {
            console.log(fetchError)
            if (fetchError) {
                this.props.actions.addNotif({ type: 'error', title: '{{lang}}Email Failed', description: fetchError.message })
                return
            }

            console.log(fetchResult)

            this.exportModal.hideModal()

            if (fetchResult.file) {

                // saveAs(siteConfig.assetsDomain + 'assets/pdfs/' + fetchResult.file)
                saveAs(siteConfig.assetsDomain + 'pdfs/' + fetchResult.file)

                this.props.actions.addNotif({ type: 'success', title: '{{lang}}PDF Created Successfuly', description: '{{lang}Pdf Has been Generated successfully' })

                // let url = assetsUrl + 'pdfs/' + data.file
                // window.open(url, '_blank');
                // console.log()
            }

            // saveAs(siteConfig.assetsDomain + fetchResult.info)

            // this.exportModal.hideModal()
        })

    }


    downloadOriginalFinancialPDF = (prop, index, reference) => {

        let body = { _id: prop._id }
        // console.log(body)
        this.exportModal.showModal()

        HttpServices.request('getOriginalInvoicePDF', body, (fetchResult, fetchError) => {
            console.log(fetchError)
            if (fetchError) {
                this.props.actions.addNotif({ type: 'error', title: '{{lang}}Email Failed', description: fetchError.message })
                return
            }

            console.log(fetchResult)

            this.exportModal.hideModal()

            if (fetchResult.file) {

                // saveAs(siteConfig.assetsDomain + 'assets/pdfs/' + fetchResult.file)
                saveAs(siteConfig.assetsDomain + 'pdfs/' + fetchResult.file)

                this.props.actions.addNotif({ type: 'success', title: '{{lang}}PDF Created Successfuly', description: '{{lang}Pdf Has been Generated successfully' })

                // let url = assetsUrl + 'pdfs/' + data.file
                // window.open(url, '_blank');
                // console.log()
            }

            // saveAs(siteConfig.assetsDomain + fetchResult.info)

            // this.exportModal.hideModal()
        })

    }

    sendFinancialEmail = (prop, index, reference) => {

        let body = { _id: prop._id }
        console.log(body)
        HttpServices.request('sendInvoiceEmail', body, (fetchResult, fetchError) => {
            console.log(fetchError)
            if (fetchError) {
                this.props.actions.addNotif({ type: 'error', title: '{{lang}}Email Failed', description: fetchError.message })
                return
            }

            // saveAs(siteConfig.assetsDomain + fetchResult.info)

            // this.exportModal.hideModal()
            this.props.actions.addNotif({ type: 'success', title: '{{lang}}Email Sent', description: '{{lang}}Email sent successfully' })
        })

    }
    SendEmailLate1 = (prop, index, reference) => {

        let body = { _id: prop._id }
        console.log(body)
        HttpServices.request('SendEmailLate1', body, (fetchResult, fetchError) => {
            console.log(fetchError)
            if (fetchError) {
                this.props.actions.addNotif({ type: 'error', title: '{{lang}}Email Failed', description: fetchError.message })
                return
            }

            // saveAs(siteConfig.assetsDomain + fetchResult.info)

            // this.exportModal.hideModal()
            this.props.actions.addNotif({ type: 'success', title: '{{lang}}Email Sent', description: '{{lang}}Email sent successfully' })
        })

    }
    SendEmailLate2 = (prop, index, reference) => {

        let body = { _id: prop._id }
        console.log(body)
        HttpServices.request('SendEmailLate2', body, (fetchResult, fetchError) => {
            console.log(fetchError)
            if (fetchError) {
                this.props.actions.addNotif({ type: 'error', title: '{{lang}}Email Failed', description: fetchError.message })
                return
            }

            // saveAs(siteConfig.assetsDomain + fetchResult.info)

            // this.exportModal.hideModal()
            this.props.actions.addNotif({ type: 'success', title: '{{lang}}Email Sent', description: '{{lang}}Email sent successfully' })
        })

    }
    SendEmailLate3 = (prop, index, reference) => {

        let body = { _id: prop._id }
        console.log(body)
        HttpServices.request('SendEmailLate3', body, (fetchResult, fetchError) => {
            console.log(fetchError)
            if (fetchError) {
                this.props.actions.addNotif({ type: 'error', title: '{{lang}}Email Failed', description: fetchError.message })
                return
            }

            // saveAs(siteConfig.assetsDomain + fetchResult.info)

            // this.exportModal.hideModal()
            this.props.actions.addNotif({ type: 'success', title: '{{lang}}Email Sent', description: '{{lang}}Email sent successfully' })
        })

    }
    SendEmailLate4 = (prop, index, reference) => {

        let body = { _id: prop._id }
        console.log(body)
        HttpServices.request('SendEmailLate4', body, (fetchResult, fetchError) => {
            console.log(fetchError)
            if (fetchError) {
                this.props.actions.addNotif({ type: 'error', title: '{{lang}}Email Failed', description: fetchError.message })
                return
            }

            // saveAs(siteConfig.assetsDomain + fetchResult.info)

            // this.exportModal.hideModal()
            this.props.actions.addNotif({ type: 'success', title: '{{lang}}Email Sent', description: '{{lang}}Email sent successfully' })
        })

    }
    SendEmailLate5 = (prop, index, reference) => {

        let body = { _id: prop._id }
        console.log(body)
        HttpServices.request('SendEmailLate5', body, (fetchResult, fetchError) => {
            console.log(fetchError)
            if (fetchError) {
                this.props.actions.addNotif({ type: 'error', title: '{{lang}}Email Failed', description: fetchError.message })
                return
            }

            // saveAs(siteConfig.assetsDomain + fetchResult.info)

            // this.exportModal.hideModal()
            this.props.actions.addNotif({ type: 'success', title: '{{lang}}Email Sent', description: '{{lang}}Email sent successfully' })
        })

    }

    extendRentalTime(prop) {
        // console.log("propssssssss :  ", prop)
        this.setState({ currentItem: prop, extendTime: '', extendPrice: '', isChecked: true, RecivedData: false, notAvailable: false })
        this.extendTime.showModal()

    }
    dedidatePlan(prop) {
        // console.log("propssssssss :  ", prop)
        this.setState({ currentItem: prop, sentPaymentLink: false, trialDays: null, subscriptionPlan: null })
        this.dedidatePlanModal.showModal()

    }
    dedidatePlanWithLink(prop) {
        // console.log("propssssssss :  ", prop)
        this.setState({ currentItem: prop, sentPaymentLink: true, trialDays: null, subscriptionPlan: null })
        this.dedidatePlanModal.showModal()

    }
    sendDedicatePlanReq = () => {
        let body = {}
        body.trialDays = this.state.trialDays
        body.subscriptionPlan = this.state.subscriptionPlan
        if (this.props.page.key == 'users') {
            body.user = this.state.currentItem

        } else {

            body.subscription = this.state.currentItem
        }

        HttpServices.request(this.props.page.key == 'users' ? 'sendDedicatePlanReqUser' : 'sendDedicatePlanReq', body, (fetchResult, fetchError) => {
            if (fetchError) {
                console.log("error dedicating plan");
                this.props.actions.addNotif({ type: 'error', title: '{{lang}}dedicate plan request Failed', description: fetchError.message })

                return
            }
            // console.log("hoooooooooo: ", fetchResult)
            if (fetchResult) {
                this.setState({ trialDays: null, subscriptionPlan: null })

                this.props.actions.addNotif({ type: 'success', title: '{{lang}}Subscription successfully created for parner', description: '' })
                this.dedidatePlanModal.hideModal()

            }

        })
    }
    sendDedicatePlanReqWithLink = () => {
        let body = {}
        body.trialDays = this.state.trialDays
        body.subscriptionPlan = this.state.subscriptionPlan
        if (this.props.page.key == 'users') {
            body.user = this.state.currentItem

        } else {

            body.subscription = this.state.currentItem
        }
        // console.log("body in extend: ", body)
        // return
        HttpServices.request(this.props.page.key == 'users' ? 'sendDedicatePlanReqWithLinkUser' : 'sendDedicatePlanReqWithLink', body, (fetchResult, fetchError) => {
            if (fetchError) {
                console.log("error dedicating plan");
                this.props.actions.addNotif({ type: 'error', title: '{{lang}}dedicate plan request Failed', description: fetchError.message })

                return
            }
            // console.log("hoooooooooo: ", fetchResult)
            if (fetchResult) {
                this.setState({ trialDays: null, subscriptionPlan: null })

                this.props.actions.addNotif({ type: 'success', title: '{{lang}}Payment link successfully sent to partner', description: '' })
                this.dedidatePlanModal.hideModal()

            }

        })
    }
    sendExtendTimeReq = (confirmed = false) => {
        this.setState({ isChecked: false })
        let body = { _id: this.state.currentItem._id, newEndDate: moment(new Date(this.state.extendTime)).tz('Asia/Singapore').startOf('day').format() }
        if (confirmed) {
            body = { ...body, confirmed: confirmed }
        }
        // console.log("body in extend: ", body)
        HttpServices.request('extendRentalTime', body, (fetchResult, fetchError) => {
            if (fetchError) {
                console.log("error extend time");
                this.props.actions.addNotif({ type: 'error', title: '{{lang}}extend time request Failed', description: fetchError.message })
                this.setState({ isChecked: true, notAvailable: true })
                return
            }
            // console.log("hoooooooooo: ", fetchResult)
            if (fetchResult.free) {
                this.setState({ RecivedData: true, extendPrice: fetchResult.extraPrice })
            } else {
                this.props.actions.addNotif({ type: 'success', title: '{{lang}}extend rental time done Successfully', description: 'Your new end date is set' })
                this.extendTime.hideModal()

            }

        })
    }
    onChangeValueExtend(e) {
        // console.log('extend time 1 ::::: ',e);
        // console.log('extend time 2 ::::: ',extendTime);
        this.setState({ extendTime: e })
    }
    onChangeValuePlan(value, type) {
        // console.log('extend time 1 ::::: ',e);
        // console.log('extend palllaaaannnnn 2 ::::: ', value, type);

        this.setState({ [type]: value })
    }

    requestAsPromise = (action, body) => {
        return new Promise((resolve, reject) => {
            HttpServices.request(action, body, (result, error) => {
                if (error) {
                    reject(error)
                } else {
                    resolve(result)
                }
            })
        })
    }

    openAiBillingModal = (prop) => {
        this.setState({
            currentItem: prop,
            aiBillingLoading: true,
            aiBillingSubmitting: false,
            aiBillingLedgerLoadingMore: false,
            aiBillingTenants: [],
            aiBillingTenantId: '',
            aiBillingSummary: null,
            aiBillingLedger: [],
            aiBillingNextCursor: null,
            aiBillingError: '',
            aiGrantCredits: '',
            aiGrantReason: '',
            aiGrantTicketRef: '',
            aiGrantIdempotencyKey: ''
        }, () => {
            this.aiBillingModal.showModal()
            this.loadAiBillingTenants()
        })
    }

    loadAiBillingTenants = () => {
        const userId = this.state.currentItem?._id
        if (!userId) {
            this.setState({ aiBillingLoading: false, aiBillingError: 'Subscriber user ID is missing.' })
            return
        }
        this.setState({ aiBillingLoading: true, aiBillingError: '' })
        this.requestAsPromise('getAdminAiBillingTenants', { userId }).then((result) => {
            if (String(this.state.currentItem?._id || '') !== String(userId)) return
            const tenants = result?.info?.tenants || []
            if (!tenants.length) {
                this.setState({ aiBillingLoading: false, aiBillingTenants: [], aiBillingTenantId: '', aiBillingError: 'This subscriber does not have an AI tenant yet.' })
                return
            }
            const tenantId = String(tenants[0]._id)
            this.setState({
                aiBillingTenants: tenants,
                aiBillingTenantId: tenantId
            }, this.refreshAiBilling)
        }).catch((error) => {
            if (String(this.state.currentItem?._id || '') !== String(userId)) return
            this.setState({ aiBillingLoading: false, aiBillingError: error?.message || 'Unable to load AI tenant choices.' })
        })
    }

    refreshAiBilling = () => {
        const userId = this.state.currentItem?._id
        const tenantId = this.state.aiBillingTenantId
        if (!userId || !tenantId) {
            this.setState({ aiBillingLoading: false, aiBillingError: 'Select an AI tenant to continue.' })
            return
        }

        this.setState({ aiBillingLoading: true, aiBillingError: '' })
        Promise.all([
            this.requestAsPromise('getAdminAiBillingSummary', { userId, tenantId }),
            this.requestAsPromise('getAdminAiBillingLedger', { userId, tenantId, limit: 50 })
        ]).then(([summaryResult, ledgerResult]) => {
            if (this.state.aiBillingTenantId !== tenantId) return
            this.setState({
                aiBillingLoading: false,
                aiBillingSummary: summaryResult?.info?.summary || null,
                aiBillingLedger: ledgerResult?.info?.items || [],
                aiBillingNextCursor: ledgerResult?.info?.nextCursor || null
            })
        }).catch((error) => {
            if (this.state.aiBillingTenantId !== tenantId) return
            this.setState({
                aiBillingLoading: false,
                aiBillingError: error?.message || 'Unable to load AI billing data.'
            })
        })
    }

    loadMoreAiBillingLedger = () => {
        const userId = this.state.currentItem?._id
        const tenantId = this.state.aiBillingTenantId
        const cursor = this.state.aiBillingNextCursor
        if (!userId || !tenantId || !cursor || this.state.aiBillingLedgerLoadingMore) return

        this.setState({ aiBillingLedgerLoadingMore: true })
        HttpServices.request('getAdminAiBillingLedger', { userId, tenantId, limit: 50, cursor }, (result, error) => {
            if (this.state.aiBillingTenantId !== tenantId) return
            if (error) {
                this.setState({ aiBillingLedgerLoadingMore: false })
                this.props.actions.addNotif({ type: 'error', title: 'Ledger could not be loaded', description: error?.message || 'Please try again.' })
                return
            }
            this.setState({
                aiBillingLedgerLoadingMore: false,
                aiBillingLedger: [...this.state.aiBillingLedger, ...(result?.info?.items || [])],
                aiBillingNextCursor: result?.info?.nextCursor || null
            })
        })
    }

    clearAiGrantForm = () => {
        this.setState({
            aiGrantCredits: '',
            aiGrantReason: '',
            aiGrantTicketRef: '',
            aiGrantIdempotencyKey: ''
        })
    }

    createAiGrantIdempotencyKey = () => {
        const userId = this.state.currentItem?._id || 'unknown'
        return `admin-grant-${userId}-${Date.now()}-${Math.random().toString(36).slice(2, 12)}`
    }

    createBulkAiGrantBatchId = () => {
        const date = moment().format('YYYY-MM-DD')
        return `admin-ai-head-start-${date}-${Math.random().toString(36).slice(2, 10)}`
    }

    canGrantAllAiCredits = () => {
        return checkPermission('admin.aiBillingTenants.edit') || checkPermission('admin.usersSubscriptions.edit')
    }

    loadStorefrontRouteConsolidation = () => {
        if (this.state.storefrontRouteLoading || this.state.storefrontRouteSubmitting) return
        this.setState({ storefrontRouteLoading: true, storefrontRouteError: '' })
        HttpServices.request('getStorefrontWorkerRouteStatus', {}, (result, error) => {
            this.setState({
                storefrontRouteLoading: false,
                storefrontRoutePreview: result?.info || null,
                storefrontRouteConfirmed: false,
                storefrontRouteError: error?.message || (!result?.info ? 'Could not load Cloudflare Worker routes.' : ''),
            })
        })
    }

    openStorefrontRouteConsolidation = () => {
        if (!checkPermission('admin.tenants.edit')) {
            this.props.actions.addNotif({ type: 'error', title: 'Permission denied', description: 'Tenant edit permission is required.' })
            return
        }
        this.setState({ storefrontRoutePreview: null, storefrontRouteConfirmed: false, storefrontRouteError: '' }, () => {
            this.storefrontRouteModal.showModal()
            this.loadStorefrontRouteConsolidation()
        })
    }

    submitStorefrontRouteConsolidation = () => {
        const preview = this.state.storefrontRoutePreview
        if (!checkPermission('admin.tenants.edit') || !preview?.canApply || !preview?.needsChanges || !this.state.storefrontRouteConfirmed || this.state.storefrontRouteSubmitting) return
        this.setState({ storefrontRouteSubmitting: true, storefrontRouteError: '' })
        HttpServices.request('syncStorefrontWorkerRoutes', {
            confirmation: 'SYNC_EXACT_STOREFRONT_WORKER_ROUTES',
        }, (result, error) => {
            const info = result?.info || null
            this.setState({
                storefrontRouteSubmitting: false,
                storefrontRoutePreview: info || preview,
                storefrontRouteConfirmed: false,
                storefrontRouteError: error?.message || (!info ? 'Cloudflare Worker routes could not be restored.' : ''),
            })
            if (!error && info) {
                this.props.actions.addNotif({
                    type: 'success',
                    title: 'Subscriber route ready',
                    description: `${info.readyRouteCount || 0} exact subscriber routes are active. Wildcard removed: ${info.wildcardRemoved ? 'yes' : 'not present'}.`,
                })
            }
        })
    }

    stopPostDeployMigrationPolling = () => {
        if (this.postDeployMigrationPoll) clearInterval(this.postDeployMigrationPoll)
        this.postDeployMigrationPoll = null
    }

    fetchPostDeployMigrationStatus = () => {
        HttpServices.request('getPostDeployMigrationStatus', {}, (result, error) => {
            if (!this.postDeployMigrationOpen) return
            if (error) {
                this.setState({ postDeployMigrationError: error?.message || 'Could not load migration status.' })
                return
            }
            this.setState({ postDeployMigrationStatus: result?.info || null, postDeployMigrationError: '' })
            const status = result?.info
            const key = status?.status === 'failed' && status?.currentStep === 'content.preview' ? status.stepStartedAt : null
            if (key && this.postDeployContentChoicesKey !== key) {
                this.postDeployContentChoicesKey = key
                this.setState({ postDeployContentLoading: true, postDeployContentError: '' })
                HttpServices.request('getPostDeployContentChoices', {}, (choicesResult, choicesError) => {
                    if (!this.postDeployMigrationOpen) return
                    this.setState({
                        postDeployContentLoading: false,
                        postDeployContentChoices: choicesResult?.info?.choices || [],
                        postDeployContentTargets: status.contentTargets || {},
                        postDeployContentError: choicesError?.message || '',
                    })
                })
            }
        })
    }

    openPostDeployMigrations = () => {
        if (!checkPermission('admin.tenants.edit')) {
            this.props.actions.addNotif({ type: 'error', title: 'Permission denied', description: 'Tenant edit permission is required.' })
            return
        }
        this.postDeployMigrationOpen = true
        this.postDeployRealmReviewRequestId = (this.postDeployRealmReviewRequestId || 0) + 1
        this.postDeployContentChoicesKey = null
        this.setState({ postDeployMigrationConfirmed: false, postDeploySearchAliasConfirmed: false, postDeployMigrationWorkerStopped: false, postDeployMigrationError: '',
            postDeployContentChoices: [], postDeployContentTargets: {}, postDeployContentLoading: false, postDeployContentError: '',
            postDeployRealmReview: null, postDeployRealmReviewLoading: false, postDeployRealmReviewError: '' }, () => {
            this.postDeployMigrationModal.showModal()
            this.fetchPostDeployMigrationStatus()
            this.stopPostDeployMigrationPolling()
            this.postDeployMigrationPoll = setInterval(this.fetchPostDeployMigrationStatus, 3000)
        })
    }

    reviewPostDeployRealmAccounts = () => {
        if (!checkPermission('admin.tenants.edit') || this.state.postDeployRealmReviewLoading) return
        const requestId = this.postDeployRealmReviewRequestId = (this.postDeployRealmReviewRequestId || 0) + 1
        this.setState({ postDeployRealmReviewLoading: true, postDeployRealmReviewError: '', postDeployRealmReview: null })
        HttpServices.request('getPostDeployRealmReview', {}, (result, error) => {
            if (!this.postDeployMigrationOpen || requestId !== this.postDeployRealmReviewRequestId) return
            this.setState({ postDeployRealmReviewLoading: false, postDeployRealmReview: result?.info || null,
                postDeployRealmReviewError: error?.message || (!result?.info ? 'No review report was returned.' : '') })
        })
    }

    startPostDeployMigrations = () => {
        if (!checkPermission('admin.tenants.edit') || !this.state.postDeployMigrationConfirmed || !this.state.postDeploySearchAliasConfirmed || this.state.postDeployMigrationSubmitting) return
        if (this.state.postDeployMigrationStatus?.stale && !this.state.postDeployMigrationWorkerStopped) return
        this.postDeployRealmReviewRequestId = (this.postDeployRealmReviewRequestId || 0) + 1
        this.setState({ postDeployMigrationSubmitting: true, postDeployMigrationError: '', postDeployRealmReview: null,
            postDeployRealmReviewLoading: false, postDeployRealmReviewError: '' })
        HttpServices.request('startPostDeployMigration', {
            confirmation: 'RUN_TENANT_CORE_MIGRATIONS',
            searchAliasConversionConfirmed: true,
            previousWorkerStopped: this.state.postDeployMigrationStatus?.stale && this.state.postDeployMigrationWorkerStopped === true,
            ...(this.state.postDeployContentChoices.length ? { contentTargets: this.state.postDeployContentTargets } : {}),
        }, (result, error) => {
            if (error && !result?.info) {
                this.setState({ postDeployMigrationSubmitting: false, postDeployMigrationError: error?.message || 'Migration could not be started.' })
                return
            }
            this.setState({
                postDeployMigrationSubmitting: false,
                postDeployMigrationConfirmed: false,
                postDeploySearchAliasConfirmed: false,
                postDeployMigrationWorkerStopped: false,
                postDeployMigrationError: error?.message || '',
                postDeployMigrationStatus: result?.info || this.state.postDeployMigrationStatus,
            })
            this.fetchPostDeployMigrationStatus()
        })
    }

    openBulkAiCreditGrant = () => {
        if (!this.canGrantAllAiCredits()) {
            this.props.actions.addNotif({ type: 'error', title: 'Permission denied', description: 'You do not have permission to set tenant Head Start credits.' })
            return
        }

        this.setState({
            bulkAiGrantCredits: 100,
            bulkAiGrantReason: '',
            bulkAiGrantTicketRef: '',
            bulkAiGrantBatchId: this.createBulkAiGrantBatchId(),
            bulkAiGrantConfirmed: false,
            bulkAiGrantSubmitting: false,
            bulkAiGrantResult: null,
            bulkAiGrantError: ''
        }, () => this.bulkAiCreditGrantModal.showModal())
    }

    submitBulkAiCreditGrant = () => {
        if (!this.canGrantAllAiCredits()) {
            this.props.actions.addNotif({ type: 'error', title: 'Permission denied', description: 'You do not have permission to set tenant Head Start credits.' })
            return
        }

        const reason = String(this.state.bulkAiGrantReason || '').trim()
        const ticketRef = String(this.state.bulkAiGrantTicketRef || '').trim()
        const batchId = String(this.state.bulkAiGrantBatchId || '').trim()

        if (reason.length < 3 || reason.length > 500) {
            this.props.actions.addNotif({ type: 'error', title: 'Reason required', description: 'Enter a reason between 3 and 500 characters.' })
            return
        }
        if (ticketRef.length > 120) {
            this.props.actions.addNotif({ type: 'error', title: 'Ticket reference is too long', description: 'Use 120 characters or fewer.' })
            return
        }
        if (batchId.length < 8 || batchId.length > 180) {
            this.props.actions.addNotif({ type: 'error', title: 'Batch ID required', description: 'Use a stable batch ID between 8 and 180 characters.' })
            return
        }
        if (!this.state.bulkAiGrantConfirmed) {
            this.props.actions.addNotif({ type: 'error', title: 'Confirmation required', description: 'Confirm the Head Start reset for every AI tenant.' })
            return
        }

        this.setState({ bulkAiGrantSubmitting: true, bulkAiGrantError: '', bulkAiGrantResult: null })
        HttpServices.request('setAllTenantsHeadStartCredits', {
            reason,
            ticketRef: ticketRef || undefined,
            batchId
        }, (result, error) => {
            if (error) {
                this.setState({ bulkAiGrantSubmitting: false, bulkAiGrantError: error?.message || 'The Head Start reset could not be completed.' })
                this.props.actions.addNotif({ type: 'error', title: 'Head Start reset failed', description: error?.message || 'Keep the same batch ID and try again.' })
                return
            }

            const info = result?.info || {}
            this.setState({
                bulkAiGrantSubmitting: false,
                bulkAiGrantResult: info,
                bulkAiGrantError: '',
                bulkAiGrantConfirmed: false
            }, () => this.fetchData(true))
            this.props.actions.addNotif({
                type: info.failed > 0 ? 'error' : 'success',
                title: info.failed > 0 ? 'Head Start reset completed with errors' : 'Head Start credits applied',
                description: `${info.updated || 0} updated, ${info.duplicates || 0} safe retries, ${info.failed || 0} failed.`
            })
        })
    }

    submitAiCreditGrant = () => {
        if (!checkPermission('admin.usersSubscriptions.edit')) {
            this.props.actions.addNotif({ type: 'error', title: 'Permission denied', description: 'You do not have permission to grant AI credits.' })
            return
        }
        if (!this.state.aiBillingTenantId) {
            this.props.actions.addNotif({ type: 'error', title: 'AI tenant required', description: 'Select the tenant that should receive credits.' })
            return
        }

        const credits = Number(this.state.aiGrantCredits)
        const reason = String(this.state.aiGrantReason || '').trim()
        const ticketRef = String(this.state.aiGrantTicketRef || '').trim()
        if (!Number.isSafeInteger(credits) || credits < 1 || credits > 1000000) {
            this.props.actions.addNotif({ type: 'error', title: 'Invalid credits', description: 'Enter a whole number from 1 to 1,000,000.' })
            return
        }
        if (reason.length < 3 || reason.length > 500) {
            this.props.actions.addNotif({ type: 'error', title: 'Reason required', description: 'Enter a reason between 3 and 500 characters.' })
            return
        }
        if (ticketRef.length > 120) {
            this.props.actions.addNotif({ type: 'error', title: 'Ticket reference is too long', description: 'Use 120 characters or fewer.' })
            return
        }

        const tenantId = this.state.aiBillingTenantId
        const idempotencyKey = this.state.aiGrantIdempotencyKey || this.createAiGrantIdempotencyKey()
        this.setState({ aiBillingSubmitting: true, aiGrantIdempotencyKey: idempotencyKey })
        HttpServices.request('grantAdminAiBillingCredits', {
            userId: this.state.currentItem?._id,
            tenantId,
            credits,
            reason,
            ticketRef: ticketRef || undefined,
            idempotencyKey
        }, (result, error) => {
            if (this.state.aiBillingTenantId !== tenantId) return
            if (error) {
                this.setState({ aiBillingSubmitting: false })
                this.props.actions.addNotif({ type: 'error', title: 'AI credit grant failed', description: error?.message || 'Please try again.' })
                return
            }

            this.setState({
                aiBillingSubmitting: false,
                aiBillingSummary: result?.info?.summary || this.state.aiBillingSummary,
                aiGrantCredits: '',
                aiGrantReason: '',
                aiGrantTicketRef: '',
                aiGrantIdempotencyKey: ''
            }, this.refreshAiBilling)
            this.props.actions.addNotif({
                type: 'success',
                title: result?.info?.grant?.duplicate ? 'Credit grant already applied' : 'AI credits granted',
                description: result?.info?.grant?.duplicate ? 'The safe retry returned the original grant.' : `${credits} credits were added successfully.`
            })
        })
    }

    formatAiBillingDate = (value) => {
        if (!value) return '—'
        const date = moment(value)
        return date.isValid() ? date.format('DD MMM YYYY, HH:mm') : '—'
    }

    aiBillingMetricRow = (label, value, options = {}) => {
        return (
            <div className="w-100" style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', gap: 20, padding: '8px 0' }}>
                <span style={{ color: '#71819b', fontSize: 15 }}>{label}</span>
                <span style={{ color: options.color || '#172033', fontWeight: options.bold ? 700 : 500, textAlign: 'right' }}>{value}</span>
            </div>
        )
    }



    downloadInsurancePDF = (prop, index, reference) => {

        let body = { _id: prop._id }
        // console.log(body)
        this.exportModal.showModal()

        HttpServices.request('getInsurancePDF', body, (fetchResult, fetchError) => {
            console.log(fetchError)
            if (fetchError) {
                this.props.actions.addNotif({ type: 'error', title: '{{lang}}Email Failed', description: fetchError.message })
                return
            }

            console.log(fetchResult)

            this.exportModal.hideModal()

            if (fetchResult.file) {

                // saveAs(siteConfig.assetsDomain + 'assets/pdfs/' + fetchResult.file)
                saveAs(siteConfig.assetsDomain + 'pdfs/' + fetchResult.file)

                this.props.actions.addNotif({ type: 'success', title: '{{lang}}PDF Created Successfuly', description: '{{lang}}Pdf Has been Generated successfully' })

                // let url = assetsUrl + 'pdfs/' + data.file
                // window.open(url, '_blank');
                // console.log()
            }

            // saveAs(siteConfig.assetsDomain + fetchResult.info)

            // this.exportModal.hideModal()
        })

    }




    openExport = () => {
        this.exportModal.showModal()
        this.fetchExport()
        // console.log("TEST")
    }

    changeTab = (index, prop) => {
        this.setState({ selectedTab: index })
        this.setState({ currentPage: 0, filter: prop ? prop.filter : {} }, () => {
            this.fetchData(true)
        })
    }

    functionsHandler = (prop, index, reference) => {
        // console.log("functionsHandler")
        // console.log(reference)
        // console.log(prop)
        if (this[reference.function]) {
            this[reference.function](prop, index, reference)
        }

    }

    getByPath=(obj, path) =>{
        return path.split('.').reduce((acc, key) => acc?.[key], obj);
      }
    Export = (a, fileName) => {

        const fileType = "application/vnd.ms-excel;charset=utf-8";
        const fileExtension = ".xlsx";

        const ws = XLSX.utils.json_to_sheet(a);
        const wb = { Sheets: { data: ws }, SheetNames: ["data"] };
        const excelBuffer = XLSX.write(wb, { bookType: "xlsx", type: "array" });
        const data = new Blob([excelBuffer], { type: fileType });
        FileSaver.saveAs(data, fileName + fileExtension);
    };


    render() {
        // console.log('props is :::::',this.props);
        return (

            <Configurer
                settingsInfo={{ showFooter: true, showTabBar: true, showHeader: true, headerTitle: checkTextTranslation(this.props.page?.title), button: { goBack: false } }}
                title={checkTextTranslation(this.props.page?.title)}
                description={checkTextTranslation(this.props.page?.description)}
                className=" "
            >
                <div className="container " >

                    <div className="row m-0 w-100 ">
                        <div className="col-12 p-0 mb-3" >
                            <div className="p-0" style={{ borderRadius: 0 }}>

                                {/* <button onClick={()=>this.Export(this.state.data,'test')}>
                                    Test
                                </button> */}
                                <div className="flexcb" style={{ flexWrap: 'wrap' }}>

                                    <div className="flexc mt-2">

                                        <ProfileImage width={54} borderRadius={50} notif={0} border={'2px solid #eee'} className={'mrd-3'} data={{ image: this.props.page?.image ?? this.props.page?.icon }} />

                                        <div>
                                            <p className="text-big font-bold m-0 " style={{ color: '#0d172a' }}>{this.props.page?.title}</p>
                                            <p className="text-small m-0" style={{ color: '#89a' }} >{this.state.totalCount ? (this.state.totalCount + " Records Found") : this.props.page?.description}</p>
                                        </div>
                                    </div>


                                    <div className="flexcc mt-2" style={{}}>


                                        {this.props.page?.extra && (
                                            <button onClick={() => this.openOptions()} className="flexcc p-0" style={{ height: 28, width: 28, borderRadius: 30, flex: 1, boxShadow: '0px 0px 15px #00000005', color: '#789' }}>
                                                <img className="" src="/images/more.svg" alt="" width="24px" />
                                            </button>
                                        )}
                                        {!this.props.page?.hideFilter && (
                                            <button onClick={() => this.openFilterModal()} className="flexcc p-0 mrd-3" style={{ flex: 1, boxShadow: '0px 0px 15px #00000005', color: '#789' }}>
                                                <img className=" " src="/images/search.svg" alt="" width="24px" />
                                                {/* <span className="text-smaller m-0 white text-bold" >Filter</span> */}
                                            </button>
                                        )}


                                        {this.props.page?.addNew != -1 && checkPermission(this.props.variables?.permissionRoot + '.create') && (
                                            <button onClick={() => this.openAddNew()} className="flexcc" style={{ boxShadow: '0px 0px 15px #00000005', backgroundImage: 'linear-gradient(#000,#102030)', border: '0px solid #e9eaf0', color: '#789', borderRadius: 30, padding: '7px 15px' }}>
                                                <img className="mrd-2 invert" src="/images/add.svg" alt="" width="12px" />
                                                <span className="text-smaller m-0 white text-bold" >Add New</span>
                                            </button>
                                        )}
                                    </div>
                                </div>


                                {this.state.filter2 && Object.values(this.state.filter2).length > 0 && (
                                    <div className="flexc mt-2 px-1">
                                        {Object.values(this.state.filter2).map((prop, index) => {
                                            return (
                                                <div key={index} className="flexcc mrd-1" style={{ backgroundColor: 'rgba(103, 125, 196, 0.082)', color: 'rgba(103, 125, 196, 0.8)', borderRadius: 20, padding: '3px 10px', fontSize: 12, }}>
                                                    {this.filterLabelCreator(prop)}
                                                    <button onClick={() => this.removeFilter(prop)} className="p-0 mld-2" style={{ color: 'rgba(103, 125, 196, 0.8)', fontSize: 12 }}>
                                                        <span className="flexcc">X</span>
                                                    </button>
                                                </div>
                                            )
                                        })}
                                    </div>
                                )}

                            </div>

                        </div>
                        {(this.props.page?.additionaldata && Array.isArray(this.props.page?.additionaldata?.headers) && this.props.page.additionaldata?.headers.length > 0) && (
                            <div className="col-12 p-0 mb-3" >
                                <div className="p-0" style={{ borderRadius: 0 }}>
                                    <GridViewer
                                        isLoading={this.state.isLoadingData}
                                        ref={''}
                                       
                                        data={this.getByPath(this.state.fullData, this.props.page.additionaldata?.key)}
                                        page={this.props.page}
                                        headers={this.props.page?.additionaldata?.headers}
                                        key={''}
                                        id={''}
                                        widths={this.state.cellWidths}
                                        scrollX={this.state.scrollX}
                                        actions={this.props.page?.actions ?? this.state.actions}
                                        settings={{ isSortable: false }}
                                    />

                                   

                                </div>

                            </div>
                        )}

                        {this.props.page?.tabs && (

                            <div className="col-12  w-100 p-0">

                                <div className="flexc">

                                    <div className="ml-0" onClick={() => { this.changeTab(null) }} style={{ fontSize: 14, cursor: 'pointer', transition: 'all 0.5s', backgroundColor: this.state.selectedTab == null ? '#677dc4' : '#9ab', borderRadius: '10px 10px 0px 0px', color: '#fff', padding: '4px 20px' }}>
                                        <p>{this.props.page.defaultTabTitle || 'All'}</p>
                                    </div>
                                    {this.props.page.tabs.map((prop, index) => {
                                        return (
                                            <div className="ml-0" onClick={() => { this.changeTab(index, prop) }} style={{ fontSize: 14, cursor: 'pointer', transition: 'all 0.5s', backgroundColor: this.state.selectedTab == index ? '#677dc4' : '#9ab', borderRadius: '10px 10px 0px 0px', color: '#fff', padding: '4px 20px' }}>
                                                <p>{prop.title}</p>
                                            </div>
                                        )
                                    })}
                                </div>
                            </div>
                        )}

                        <div className="col-12 w-100 p-0">

                            <TableViewer
                                isLoading={this.state.isLoadingData}
                                headers={this.props.page?.headers}
                                page={this.props.page}
                                data={this.state.data}
                                variables={this.props.variables}
                                actions={this.props.page?.actions ?? this.state.actions}
                                settings={{ isSortable: false }}
                                openEditModal={this.openEditModal}
                                // openEditModal={this.openEditModal}
                                sendFinancialEmail={this.sendFinancialEmail}
                                openRemoveModal={this.openRemoveModal}
                                updateData={this.updateData}
                                functionsHandler={this.functionsHandler}
                                ref={el => this.TableViewer = el}
                            />

                        </div>

                        <div className="w-100  col-12 col-md-12 p-0">
                            <Pagination currentPage={this.state.currentPage} totalCount={this.state.totalCount} limit={this.state.limit} changePage={this.changePage} />
                        </div>


                    </div>



                    <FilterModal
                        ref={el => this.filterModal = el}
                        initData={this.state.filter2}
                        page={this.props.page}
                        headers={this.props.page?.headers}
                        doFilter={this.doFilter}
                        variables={this.props.variables}
                    />


                    <ItemModal
                        ref={el => this.itemModal = el}
                        page={this.props.page}
                        hideForm={this.state.hideForm}
                        headers={this.props.page?.headers}
                        initData={this.state.data[this.state.currentIndex]}
                        variables={this.props.variables}
                        itemAdded={this.itemAdded}
                        itemEdited={this.itemEdited}
                        openRefModal={this.openRefModal}
                        functionsHandler={this.functionsHandler}
                        showDates={true}
                    />
                    <ConvertModal
                        ref={el => this.ConvertModal = el}
                        page={this.props.page}
                        headers={this.props.page?.convertHeaders}
                        initData={this.state.currentItem}
                        variables={this.props.variables}
                        itemAdded={this.itemAdded}
                        itemEdited={this.itemEdited}
                        openRefModal={this.openRefModal}
                        functionsHandler={this.functionsHandler}
                        showDates={true}
                        convert={true}
                    />


                    {this.state.extraItems && this.state.extraItems.map((prop, index) => {
                        // console.log('admin.'+prop.page?.key)
                        return (

                            <ItemModal
                                ref={el => this["itemModal" + index] = el}
                                page={prop.page}
                                headers={prop.page?.headers}
                                initData={prop.data}
                                variables={{ ...{ permissionRoot: 'admin.' + prop.key }, ...this.props.variables }}
                                itemAdded={this.itemAdded}
                                itemEdited={this.itemEdited}
                                openRefModal={this.openRefModal}
                                functionsHandler={this.functionsHandler}
                                hideForm={this.state.hideForm}
                                showDates={true}
                                modalIndex={index}
                            />

                        )

                    })}


                    <RemoveModal
                        isLoading={this.state.isLoadingRemove}
                        removeFunction={this.fetchRemove}
                        ref={el => this.removeModal = el}
                    />

                    <OptionsListModal ref={el => this.optionsModal = el}
                        options={this.state.options}
                    />
                    <ImportModal closeModal={() => this.ImportModal.modal.hideModal()} ref={el => this.ImportModal = el} data={this.state?.course} page={this.props.page} headers={this.props.page?.headers} colors={this.props.colors} />

                    <Modal
                        ref={el => this.aiPlanPublicationModal = el}
                        maxWidth={'760px'}
                        onHide={() => this.setState({ aiPlanPublicationConfirmed: false })}
                    >
                        <div style={{ background: '#fff', padding: 24, borderRadius: 12 }}>
                            <h3 style={{ marginTop: 0 }}>Publish AI website USD plans</h3>
                            <p>This is separate from the tenant migrations. Preview all six Agent, Sales and Rental+ prices before publishing. Existing SGD subscriber plans stay unchanged.</p>
                            {this.state.aiPlanModeSelectionEnabled && <label style={{ display: 'block', marginBottom: 12 }}>
                                Stripe environment on develop{' '}
                                <select aria-label="Stripe environment on develop" disabled={this.state.aiPlanPublicationSubmitting}
                                    value={this.state.aiPlanPublicationMode || this.state.aiPlanPublicationPreview?.selectedMode || 'live'}
                                    onChange={event => this.setState({ aiPlanPublicationMode: event.target.value }, this.loadAiWebsitePublicationPreview)}>
                                    <option value="test">Test — no real payments</option>
                                    <option value="live">Live — real payments</option>
                                </select>
                                <small style={{ display: 'block' }}>Test publication creates separate test prices. Live prices and existing subscribers are unchanged.</small>
                            </label>}
                            {this.state.aiPlanPublicationLoading && <p>Loading publication preview…</p>}
                            {(() => {
                                const preview = this.state.aiPlanPublicationPreview
                                if (!preview) return null
                                return <>
                                    <p><strong>Catalogue version:</strong> {preview.commercialVersion} · <strong>Stripe mode:</strong> {preview.stripeMode}</p>
                                    {preview.run?.status && <p><strong>Last publication attempt:</strong> {preview.run.status}</p>}
                                    <div style={{ maxHeight: 280, overflowY: 'auto', border: '1px solid #e3e7ed', borderRadius: 8, padding: 12 }}>
                                        {(preview.plans || []).map(plan => <div key={plan.code} style={{ padding: '6px 0', borderBottom: '1px solid #eef0f3' }}>
                                            <strong>{plan.name} · {plan.period}</strong> — {plan.expectedCurrency} {plan.expectedAmount}
                                            <span style={{ marginLeft: 8, color: plan.publicationNeedsRepair || !plan.draftPresent || !plan.termsMatch ? '#b42318' : '#157347' }}>
                                                {plan.published ? 'Published' : plan.publicationNeedsRepair ? 'Saved test price unavailable in this Stripe account — republish' : plan.draftPresent && plan.termsMatch ? 'Draft ready' : plan.draftPresent ? 'Draft terms differ' : 'USD draft missing'}
                                            </span>
                                            <small style={{ display: 'block', color: '#687589' }}>Legacy subscribers retained: {plan.legacySubscribers}</small>
                                        </div>)}
                                    </div>
                                    {!preview.readyToPublish && <p role="alert" style={{ color: '#9a6700', marginTop: 12 }}>
                                        Publication is unavailable. Import the versioned USD drafts with “Import AI website content”, then verify the intended database and Stripe configuration.
                                    </p>}
                                    {preview.readyToPublish && <label style={{ display: 'block', marginTop: 18 }}>
                                        <input type="checkbox" checked={this.state.aiPlanPublicationConfirmed}
                                            onChange={event => this.setState({ aiPlanPublicationConfirmed: event.target.checked })} />{' '}
                                        I reviewed all six USD prices and confirm this is the intended database and {preview.stripeMode} Stripe account.
                                    </label>}
                                </>
                            })()}
                            {this.state.aiPlanPublicationError && <p role="alert" style={{ color: '#b42318' }}>{this.state.aiPlanPublicationError}</p>}
                            <div style={{ display: 'flex', justifyContent: 'flex-end', gap: 10, marginTop: 20 }}>
                                <button type="button" onClick={() => this.aiPlanPublicationModal.hideModal()} disabled={this.state.aiPlanPublicationSubmitting}>Close</button>
                                <button type="button" onClick={this.loadAiWebsitePublicationPreview} disabled={this.state.aiPlanPublicationLoading || this.state.aiPlanPublicationSubmitting}>Refresh preview</button>
                                <button type="button" onClick={this.submitAiWebsitePublication}
                                    disabled={!this.state.aiPlanPublicationPreview?.readyToPublish || this.state.aiPlanPublicationPreview?.run?.status === 'running' || !this.state.aiPlanPublicationConfirmed || this.state.aiPlanPublicationLoading || this.state.aiPlanPublicationSubmitting}>
                                    {this.state.aiPlanPublicationSubmitting ? 'Publishing…' : `Publish six ${this.state.aiPlanPublicationPreview?.stripeMode === 'test' ? 'TEST ' : ''}USD plans`}
                                </button>
                            </div>
                        </div>
                    </Modal>
                    <Modal
                        ref={el => this.storefrontRouteModal = el}
                        maxWidth={'720px'}
                        onHide={() => this.setState({ storefrontRouteConfirmed: false })}
                    >
                        <div style={{ background: '#fff', padding: 24, borderRadius: 12 }}>
                            <h3 style={{ marginTop: 0 }}>Subscriber storefront Worker route</h3>
                            <p>Restore and verify one separate Cloudflare Worker route for every subscriber Web Store Domain. Customer-owned custom domains remain unchanged.</p>
                            {this.state.storefrontRouteLoading && <p>Loading Cloudflare routes…</p>}
                            {this.state.storefrontRoutePreview && (() => {
                                const preview = this.state.storefrontRoutePreview
                                return <>
                                    <p><strong>Worker:</strong> {preview.workerScript}</p>
                                    <p><strong>Exact routes ready:</strong> {preview.readyRouteCount || 0} / {preview.expectedRouteCount || 0}</p>
                                    <p><strong>Missing exact routes:</strong> {preview.missingRouteCount || 0}</p>
                                    {!!preview.missingRoutes?.length && <div style={{ maxHeight: 150, overflowY: 'auto', background: '#f7f8fc', padding: 12 }}>
                                        {preview.missingRoutes.map(pattern => <div key={pattern}>{pattern}</div>)}
                                    </div>}
                                    {preview.wildcardPresent && <p role="alert" style={{ color: '#b42318' }}>Wildcard route {preview.wildcardPattern} is active. It will be removed only after every exact route is restored.</p>}
                                    {!preview.needsChanges && <p style={{ color: '#067647' }}>Every subscriber has a separate exact Worker route and no wildcard route exists.</p>}
                                    {!!preview.conflictingRoutes?.length && <p role="alert" style={{ color: '#b42318' }}>Some exact routes belong to another Worker. Resolve those conflicts before running this action.</p>}
                                    {preview.needsChanges && preview.canApply && <label style={{ display: 'block', marginTop: 18 }}>
                                        <input type="checkbox" checked={this.state.storefrontRouteConfirmed}
                                            onChange={event => this.setState({ storefrontRouteConfirmed: event.target.checked })} />{' '}
                                        I confirm this is the intended Cloudflare zone and Worker. Restore every exact subscriber route, then remove the wildcard route.
                                    </label>}
                                </>
                            })()}
                            {this.state.storefrontRouteError && <p role="alert" style={{ color: '#b42318' }}>{this.state.storefrontRouteError}</p>}
                            <div style={{ display: 'flex', justifyContent: 'flex-end', gap: 10, marginTop: 20 }}>
                                <button type="button" onClick={() => this.storefrontRouteModal.hideModal()} disabled={this.state.storefrontRouteSubmitting}>Close</button>
                                <button type="button" onClick={this.loadStorefrontRouteConsolidation} disabled={this.state.storefrontRouteLoading || this.state.storefrontRouteSubmitting}>Refresh</button>
                                <button type="button" onClick={this.submitStorefrontRouteConsolidation}
                                    disabled={!this.state.storefrontRoutePreview?.canApply || !this.state.storefrontRoutePreview?.needsChanges || !this.state.storefrontRouteConfirmed || this.state.storefrontRouteLoading || this.state.storefrontRouteSubmitting}>
                                    {this.state.storefrontRouteSubmitting ? 'Restoring…' : 'Restore exact routes'}
                                </button>
                            </div>
                        </div>
                    </Modal>
                    <Modal
                        ref={el => this.postDeployMigrationModal = el}
                        maxWidth={'720px'}
                        onHide={() => {
                            this.postDeployMigrationOpen = false
                            this.stopPostDeployMigrationPolling()
                            this.setState({ postDeployMigrationConfirmed: false, postDeploySearchAliasConfirmed: false, postDeployMigrationWorkerStopped: false })
                        }}
                    >
                        <div style={{ background: '#fff', padding: 24, borderRadius: 12 }}>
                            <h3 style={{ marginTop: 0 }}>Post-deploy tenant migrations</h3>
                            <p>Run the tenant, billing-account, content, search, user-realm and duplicate-agent migrations in their required order. Each database step previews, applies and validates before the next begins. If the serving search name is still a physical index, the migrator first creates and verifies a rollback copy, then converts the serving name into an alias. Search reindex keeps the previous verified index for rollback. Duplicate agents are archived, and the oldest agent in each workspace is kept.</p>
                            <p>Stripe plan publication is a separate action after provider price review. This migration does not change subscribers’ plans or credits.</p>
                            {(() => {
                                const status = this.state.postDeployMigrationStatus
                                const completed = new Set(status?.completed || [])
                                return <>
                                    <p><strong>Status:</strong> {status?.status || 'Loading…'} {status?.currentStep ? `— ${status.currentStep}` : ''} ({completed.size}/{status?.total || 20})</p>
                                    {status?.currentStep && <p style={{ color: '#687589', fontSize: 13 }}>
                                        Step started: {status.stepStartedAt ? new Date(status.stepStartedAt).toLocaleString() : 'Unavailable for this older run'}
                                        {status.lastOutputAt ? ` · Latest script output: ${new Date(status.lastOutputAt).toLocaleString()}` : ' · Waiting for script output'}
                                    </p>}
                                    {status?.lastOutput && <pre aria-label="Latest migration output" style={{ whiteSpace: 'pre-wrap', overflowWrap: 'anywhere', maxHeight: 140, overflowY: 'auto', fontSize: 12, background: '#f7f8fc', padding: 12 }}>
                                        {status.lastOutput}
                                    </pre>}
                                    {status?.stale && <p role="alert" style={{ color: '#9a6700' }}>The worker has not reported a heartbeat for two minutes. Stop the previous API worker and its migration child before resuming; a missing heartbeat alone does not prove they have stopped.</p>}
                                    <p>Resume skips completed steps. An interrupted step runs again. Once every step is complete, running this action again does nothing.</p>
                                    {status?.status === 'pending' && <p>New migration steps were added after the previous run. Only those unfinished steps will run.</p>}
                                    <div style={{ maxHeight: 260, overflowY: 'auto', border: '1px solid #e3e7ed', borderRadius: 8, padding: 12 }}>
                                        {(status?.steps || []).map(step => <div key={step.id} style={{ padding: '4px 0' }}>
                                            {completed.has(step.id) ? '✓ ' : status?.currentStep === step.id ? '⏳ ' : '○ '}{step.label}
                                        </div>)}
                                    </div>
                                    {(status?.error || this.state.postDeployMigrationError) && <p role="alert" style={{ color: '#b42318', marginTop: 12 }}>
                                        {status?.error || this.state.postDeployMigrationError}
                                    </p>}
                                    {(status?.realmEmailConflicts?.duplicates?.length > 0 || status?.realmEmailConflicts?.normalizationConflicts?.length > 0) && <div aria-label="Conflicting user realm emails" style={{ marginTop: 12 }}>
                                        <p>These accounts share an email in the same realm, or a stale email normalization occupies another account’s email. Review their workspace ownership, subscriptions and account history before correcting the affected records, then resume. No accounts are automatically merged or removed.</p>
                                        <div style={{ maxHeight: 260, overflow: 'auto', border: '1px solid #e3e7ed', borderRadius: 8, padding: 12 }}>
                                            {['duplicates', 'normalizationConflicts'].flatMap(kind => (status.realmEmailConflicts[kind] || []).map(group => <div key={`${kind}:${group.ownerKey}:${group.emailLower}`} style={{ marginBottom: 16, overflowWrap: 'anywhere' }}>
                                                <strong>{group.emailLower}</strong>
                                                <div>Realm: {group.ownerKey} · {kind === 'duplicates' ? 'Duplicate source email' : 'Existing normalized email conflict'}</div>
                                                <div>Account IDs: {group.userIds.join(', ')}</div>
                                            </div>))}
                                        </div>
                                    </div>}
                                    {status?.status === 'failed' && status.currentStep === 'content.preview' && <LegacyContentWorkspaceChoices
                                        choices={this.state.postDeployContentChoices} targets={this.state.postDeployContentTargets}
                                        loading={this.state.postDeployContentLoading} error={this.state.postDeployContentError}
                                        onChange={(owner, tenant) => this.setState({ postDeployContentTargets: {
                                            ...this.state.postDeployContentTargets, [owner]: tenant,
                                        }, postDeployMigrationConfirmed: false, postDeploySearchAliasConfirmed: false })}
                                    />}
                                    {status?.status === 'failed' && status.currentStep?.startsWith('realm.') && <RealmDuplicateAccountReview
                                        report={this.state.postDeployRealmReview} loading={this.state.postDeployRealmReviewLoading}
                                        error={this.state.postDeployRealmReviewError} onReview={this.reviewPostDeployRealmAccounts}
                                    />}
                                    {(status?.status !== 'running' || status?.stale) && status?.status !== 'complete' && <label style={{ display: 'block', marginTop: 18 }}>
                                        <input type="checkbox" checked={this.state.postDeployMigrationConfirmed} onChange={event => this.setState({ postDeployMigrationConfirmed: event.target.checked })} />{' '}
                                        I confirm the deployed API is connected to the intended database and search cluster.
                                    </label>}
                                    {(status?.status !== 'running' || status?.stale) && status?.status !== 'complete' && <label style={{ display: 'block', marginTop: 12 }}>
                                        <input type="checkbox" checked={this.state.postDeploySearchAliasConfirmed} onChange={event => this.setState({ postDeploySearchAliasConfirmed: event.target.checked })} />{' '}
                                        I authorize the migrator to create and verify a rollback copy and convert a legacy physical equipment search index into the serving alias when required.
                                    </label>}
                                    {status?.stale && <label style={{ display: 'block', marginTop: 12 }}>
                                        <input type="checkbox" checked={this.state.postDeployMigrationWorkerStopped === true}
                                            onChange={event => this.setState({ postDeployMigrationWorkerStopped: event.target.checked })} />{' '}
                                        I confirm the previous API migration worker and its child process have stopped.
                                    </label>}
                                    <div style={{ display: 'flex', justifyContent: 'flex-end', gap: 10, marginTop: 20 }}>
                                        <button type="button" onClick={() => this.postDeployMigrationModal.hideModal()}>Close</button>
                                        <button type="button" onClick={this.startPostDeployMigrations}
                                            disabled={!status || (status.status === 'running' && !status.stale) || status.status === 'complete' || !this.state.postDeployMigrationConfirmed || !this.state.postDeploySearchAliasConfirmed || (status.stale && !this.state.postDeployMigrationWorkerStopped) || this.state.postDeployMigrationSubmitting || (status.status === 'failed' && status.currentStep === 'content.preview' && (this.state.postDeployContentLoading || this.state.postDeployContentError || this.state.postDeployContentChoices.some(choice => !this.state.postDeployContentTargets[choice.owner])))}>
                                            {this.state.postDeployMigrationSubmitting ? 'Starting…' : status?.status === 'failed' || status?.status === 'pending' || status?.stale ? 'Resume migrations' : 'Run migrations'}
                                        </button>
                                    </div>
                                </>
                            })()}
                        </div>
                    </Modal>
                    <Modal
                        ref={el => this.bulkAiCreditGrantModal = el}
                        maxWidth={'720px'}
                        onHide={() => this.setState({ bulkAiGrantConfirmed: false })}
                    >
                        <div className="w-100" style={{ background: '#f7f8fc', borderRadius: 16, overflow: 'hidden', boxShadow: '0 18px 55px rgba(23, 32, 51, 0.18)' }}>
                            <div style={{ padding: '20px 24px', background: '#fff', borderBottom: '1px solid #e8eaf1', display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: 20 }}>
                                <div>
                                    <p className="m-0" style={{ color: '#172033', fontSize: 21, fontWeight: 750 }}>Set Head Start credits for all tenants</p>
                                    <p className="m-0 mt-1" style={{ color: '#71819b', fontSize: 13 }}>Audited balance reset with safe retry protection.</p>
                                </div>
                                <button
                                    type="button"
                                    aria-label="Close Head Start credit reset"
                                    disabled={this.state.bulkAiGrantSubmitting}
                                    onClick={() => this.bulkAiCreditGrantModal.hideModal()}
                                    style={{ width: 34, height: 34, borderRadius: '50%', background: '#f1f4f8', display: 'flex', alignItems: 'center', justifyContent: 'center', opacity: this.state.bulkAiGrantSubmitting ? 0.45 : 1 }}
                                >
                                    <img style={{ width: 13, height: 13 }} src="/images/close.svg" alt="" />
                                </button>
                            </div>

                            <div style={{ padding: 24 }}>
                                <div style={{ border: '1px solid #ffd78b', background: '#fff8e8', borderRadius: 12, padding: '14px 16px', color: '#68470b' }}>
                                    <p className="m-0" style={{ fontWeight: 700, fontSize: 14 }}>This affects every AI tenant</p>
                                    <p className="m-0 mt-1" style={{ fontSize: 13, lineHeight: 1.55 }}>
                                        Every tenant will finish with exactly <strong>100 usable remaining AI credits</strong>. Existing top-up credits will be cleared, Free Credits will be turned off, and an active verified entitlement period will be established when needed.
                                    </p>
                                </div>

                                <div style={{ display: 'flex', flexWrap: 'wrap', gap: 16, marginTop: 20 }}>
                                    <label style={{ display: 'block', flex: '1 1 250px' }}>
                                        <span style={{ display: 'block', color: '#34445d', fontSize: 13, fontWeight: 700, marginBottom: 7 }}>Remaining credits after reset</span>
                                        <input
                                            type="number"
                                            value="100"
                                            disabled
                                            readOnly
                                            style={{ width: '100%', height: 44, border: '1px solid #dfe3eb', borderRadius: 9, padding: '0 12px', color: '#172033', background: '#eef1f5', fontWeight: 700 }}
                                        />
                                    </label>
                                    <label style={{ display: 'block', flex: '1 1 250px' }}>
                                        <span style={{ display: 'block', color: '#34445d', fontSize: 13, fontWeight: 700, marginBottom: 7 }}>Ticket / change reference</span>
                                        <input
                                            type="text"
                                            maxLength="120"
                                            placeholder="e.g. OPS-2026-104"
                                            value={this.state.bulkAiGrantTicketRef}
                                            disabled={this.state.bulkAiGrantSubmitting}
                                            onChange={(event) => this.setState({ bulkAiGrantTicketRef: event.target.value, bulkAiGrantResult: null, bulkAiGrantError: '' })}
                                            style={{ width: '100%', height: 44, border: '1px solid #dfe3eb', borderRadius: 9, padding: '0 12px', color: '#172033', background: '#fff' }}
                                        />
                                    </label>
                                </div>

                                <label style={{ display: 'block', marginTop: 16 }}>
                                    <span style={{ display: 'block', color: '#34445d', fontSize: 13, fontWeight: 700, marginBottom: 7 }}>Reason *</span>
                                    <textarea
                                        rows="3"
                                        maxLength="500"
                                        placeholder="Explain why this Head Start reset is being applied. This is saved in the billing audit ledger."
                                        value={this.state.bulkAiGrantReason}
                                        disabled={this.state.bulkAiGrantSubmitting}
                                        onChange={(event) => this.setState({ bulkAiGrantReason: event.target.value, bulkAiGrantResult: null, bulkAiGrantError: '' })}
                                        style={{ width: '100%', resize: 'vertical', border: '1px solid #dfe3eb', borderRadius: 9, padding: '11px 12px', color: '#172033', background: '#fff', lineHeight: 1.5 }}
                                    />
                                </label>

                                <label style={{ display: 'block', marginTop: 16 }}>
                                    <span style={{ display: 'block', color: '#34445d', fontSize: 13, fontWeight: 700, marginBottom: 7 }}>Stable batch ID *</span>
                                    <input
                                        type="text"
                                        maxLength="180"
                                        value={this.state.bulkAiGrantBatchId}
                                        disabled={this.state.bulkAiGrantSubmitting}
                                        onChange={(event) => this.setState({ bulkAiGrantBatchId: event.target.value, bulkAiGrantResult: null, bulkAiGrantError: '' })}
                                        style={{ width: '100%', height: 44, border: '1px solid #dfe3eb', borderRadius: 9, padding: '0 12px', color: '#172033', background: '#fff', fontFamily: 'monospace', fontSize: 13 }}
                                    />
                                    <span style={{ display: 'block', color: '#71819b', fontSize: 12, marginTop: 6 }}>Keep this ID unchanged when retrying the same reset. Completed tenants will not be reset twice.</span>
                                </label>

                                {this.state.bulkAiGrantError && (
                                    <div role="alert" style={{ marginTop: 18, border: '1px solid #f5b7b7', background: '#fff1f1', color: '#a52b2b', borderRadius: 10, padding: '12px 14px', fontSize: 13 }}>
                                        <strong>Reset failed.</strong> {this.state.bulkAiGrantError} Keep the same batch ID before retrying.
                                    </div>
                                )}

                                {this.state.bulkAiGrantResult && (() => {
                                    const result = this.state.bulkAiGrantResult
                                    const failedItems = (result.results || []).filter((item) => !item?.ok)
                                    return (
                                        <div style={{ marginTop: 18, border: `1px solid ${result.failed > 0 ? '#ffd78b' : '#9fdcc9'}`, background: result.failed > 0 ? '#fffaf0' : '#effbf6', borderRadius: 12, padding: 16 }}>
                                            <p className="m-0" style={{ color: '#172033', fontWeight: 750 }}>Head Start reset result</p>
                                            <div style={{ display: 'flex', flexWrap: 'wrap', gap: 10, marginTop: 12 }}>
                                                {[
                                                    ['Tenants', result.totalTenants || 0],
                                                    ['Updated', result.updated || 0],
                                                    ['Safe retries', result.duplicates || 0],
                                                    ['Failed', result.failed || 0],
                                                ].map(([label, value]) => (
                                                    <div key={label} style={{ flex: '1 1 110px', borderRadius: 9, padding: '10px 11px', background: '#fff', border: '1px solid rgba(113,129,155,0.16)' }}>
                                                        <span style={{ display: 'block', color: '#71819b', fontSize: 11 }}>{label}</span>
                                                        <strong style={{ display: 'block', color: label === 'Failed' && value > 0 ? '#c43f3f' : '#172033', fontSize: 18, marginTop: 2 }}>{value}</strong>
                                                    </div>
                                                ))}
                                            </div>
                                            {failedItems.length > 0 && (
                                                <div style={{ marginTop: 12, maxHeight: 130, overflow: 'auto', borderTop: '1px solid #eadbbd', paddingTop: 10 }}>
                                                    {failedItems.map((item) => (
                                                        <p key={item.tenantId} className="m-0 mb-1" style={{ color: '#9b4a35', fontSize: 12 }}>
                                                            <strong>{item.tenantId}</strong>: {item.error || 'Head Start reset failed.'}
                                                        </p>
                                                    ))}
                                                </div>
                                            )}
                                        </div>
                                    )
                                })()}

                                <label style={{ display: 'flex', alignItems: 'flex-start', gap: 10, marginTop: 20, cursor: this.state.bulkAiGrantSubmitting ? 'default' : 'pointer' }}>
                                    <input
                                        type="checkbox"
                                        checked={this.state.bulkAiGrantConfirmed}
                                        disabled={this.state.bulkAiGrantSubmitting}
                                        onChange={(event) => this.setState({ bulkAiGrantConfirmed: event.target.checked })}
                                        style={{ width: 18, height: 18, marginTop: 1 }}
                                    />
                                    <span style={{ color: '#34445d', fontSize: 13, lineHeight: 1.5 }}>
                                        I confirm every AI tenant should be reset to <strong>100 usable remaining credits</strong>, with <strong>0 top-up credits</strong> and <strong>Free Credits off</strong>.
                                    </span>
                                </label>

                                <div style={{ display: 'flex', justifyContent: 'flex-end', gap: 10, marginTop: 22 }}>
                                    <button
                                        type="button"
                                        disabled={this.state.bulkAiGrantSubmitting}
                                        onClick={() => this.bulkAiCreditGrantModal.hideModal()}
                                        style={{ minWidth: 100, padding: '10px 18px', borderRadius: 22, color: '#506078', background: '#fff', border: '1px solid #dfe3eb', fontWeight: 650, opacity: this.state.bulkAiGrantSubmitting ? 0.5 : 1 }}
                                    >
                                        Close
                                    </button>
                                    <button
                                        type="button"
                                        disabled={this.state.bulkAiGrantSubmitting || !this.state.bulkAiGrantConfirmed}
                                        onClick={this.submitBulkAiCreditGrant}
                                        style={{ minWidth: 190, padding: '10px 18px', borderRadius: 22, color: '#fff', background: '#172033', fontWeight: 750, opacity: this.state.bulkAiGrantSubmitting || !this.state.bulkAiGrantConfirmed ? 0.48 : 1 }}
                                    >
                                        {this.state.bulkAiGrantSubmitting ? 'Resetting all tenants…' : this.state.bulkAiGrantResult?.failed > 0 ? 'Retry failed safely' : 'Set Head Start credits'}
                                    </button>
                                </div>
                            </div>
                        </div>
                    </Modal>

                    <Modal ref={el => this.exportModal = el} maxWidth={300}>
                        <div className="pb-5 w-100 h-100">
                            <div className="w-100 h-100" style={{ backgroundColor: '#fff', overflow: 'auto', borderRadius: 8 }}>
                                <div className="w-100" style={{ zIndex: 1, padding: '12px 22px', display: 'flex', justifyContent: 'space-between', alignItems: 'center', borderBottom: '0px #eee solid', backgroundColor: '#f2f6f8ee', background: 'linear-gradient(to right,#d7e2f7dd,#dad6e4dd)', backdropFilter: 'blur(10px) saturate(180%)', WebkitBackdropFilter: 'blur(10px) saturate(180%)', borderRadius: '8px 8px 0px 0px' }}>

                                    <p className="text-bold mb-0 text-normal ">Export</p>

                                    <div className="cursor-pointer" onClick={() => this.exportModal.hideModal()} style={{ width: 30, height: 30, borderRadius: '50%', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                                        <img style={{ width: 14, height: 14 }} src="/images/close.svg" alt="" />
                                    </div>

                                </div>
                                <div className="py-4 px-3 pb-2 w-100 text-center">
                                    <Loader
                                        type="Oval"
                                        color="#789"
                                        height="50"
                                        width="50"
                                    />
                                    <p>Exporting in process ...</p>
                                    <p className="text-smaller" style={{ color: '#789' }}>Wait till it is completed</p>

                                </div>

                            </div>
                        </div>

                    </Modal>
                    <Modal
                        ref={el => this.aiBillingModal = el}
                        maxWidth={'900px'}
                        onHide={() => this.setState({
                            aiBillingError: '',
                            aiBillingTenants: [],
                            aiBillingTenantId: '',
                            aiGrantCredits: '',
                            aiGrantReason: '',
                            aiGrantTicketRef: '',
                            aiGrantIdempotencyKey: ''
                        })}
                    >
                        <div className="w-100" style={{ background: '#f7f8fc', borderRadius: 16, overflow: 'hidden', boxShadow: '0 18px 55px rgba(23, 32, 51, 0.16)' }}>
                            <div style={{ padding: '18px 24px', background: '#fff', borderBottom: '1px solid #e8eaf1', display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: 20 }}>
                                <div>
                                    <p className="m-0" style={{ color: '#172033', fontSize: 20, fontWeight: 700 }}>AI Billing</p>
                                    <p className="m-0 mt-1" style={{ color: '#71819b', fontSize: 13 }}>
                                        {this.state.currentItem?.company || this.state.currentItem?.name || this.state.currentItem?.email || 'Subscriber'}
                                    </p>
                                </div>
                                <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
                                    <select
                                        aria-label="AI tenant"
                                        value={this.state.aiBillingTenantId}
                                        disabled={this.state.aiBillingLoading || this.state.aiBillingSubmitting || !this.state.aiBillingTenants.length}
                                        onChange={(event) => this.setState({
                                            aiBillingTenantId: event.target.value,
                                            aiBillingSummary: null,
                                            aiBillingLedger: [],
                                            aiBillingNextCursor: null
                                        }, this.refreshAiBilling)}
                                        style={{ maxWidth: 220, border: '1px solid #dfe3eb', borderRadius: 9, padding: '8px 10px', color: '#34445d', background: '#fff' }}
                                    >
                                        {!this.state.aiBillingTenants.length && <option value="">No AI tenant</option>}
                                        {this.state.aiBillingTenants.map((tenant) => (
                                            <option key={tenant._id} value={tenant._id}>
                                                {tenant.name || tenant.domain || tenant.customDomain || tenant._id}
                                            </option>
                                        ))}
                                    </select>
                                    <button
                                        type="button"
                                        disabled={this.state.aiBillingLoading}
                                        onClick={this.refreshAiBilling}
                                        style={{ border: '1px solid #dfe3eb', borderRadius: 9, padding: '8px 14px', color: '#506078', background: '#fff', opacity: this.state.aiBillingLoading ? 0.55 : 1 }}
                                    >
                                        Refresh
                                    </button>
                                    <button
                                        type="button"
                                        aria-label="Close AI billing"
                                        onClick={() => this.aiBillingModal.hideModal()}
                                        style={{ width: 34, height: 34, borderRadius: 20, display: 'flex', alignItems: 'center', justifyContent: 'center', background: '#f3f5f8' }}
                                    >
                                        <img style={{ width: 13, height: 13 }} src="/images/close.svg" alt="" />
                                    </button>
                                </div>
                            </div>

                            {this.state.aiBillingLoading && (
                                <div style={{ minHeight: 320, display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', color: '#71819b' }}>
                                    <Loader type="Oval" color="#20a878" height="46" width="46" />
                                    <p className="mt-3">Loading plan and usage…</p>
                                </div>
                            )}

                            {!this.state.aiBillingLoading && this.state.aiBillingError && (
                                <div style={{ margin: 24, padding: 20, border: '1px solid #f4c7c3', background: '#fff6f5', borderRadius: 12, color: '#a33b32' }}>
                                    <p className="m-0" style={{ fontWeight: 700 }}>AI billing could not be loaded</p>
                                    <p className="m-0 mt-2" style={{ fontSize: 13 }}>{this.state.aiBillingError}</p>
                                    <button type="button" onClick={this.refreshAiBilling} style={{ marginTop: 14, padding: '8px 14px', borderRadius: 8, background: '#a33b32', color: '#fff' }}>Try again</button>
                                </div>
                            )}

                            {!this.state.aiBillingLoading && !this.state.aiBillingError && this.state.aiBillingSummary && (() => {
                                const summary = this.state.aiBillingSummary
                                const credits = summary.credits || {}
                                const subscription = summary.subscription || {}
                                const period = summary.period || {}
                                const ratio = Math.max(0, Math.min(1, Number(credits.utilizationRatio) || 0))
                                const currentPlan = subscription.planName || this.state.currentItem?.subscriptionPlan?.name || 'No AI plan'
                                return (
                                    <div style={{ padding: 24 }}>
                                        <div style={{ background: '#fff', border: '1px solid #e4e7ef', borderRadius: 16, padding: '22px 24px', boxShadow: '0 8px 22px rgba(33, 44, 69, 0.05)' }}>
                                            <p className="m-0 mb-3" style={{ fontSize: 18, fontWeight: 700, color: '#172033' }}>Plan &amp; Usage</p>
                                            {this.aiBillingMetricRow('Current Plan', `${currentPlan}${credits.included != null ? ` (${credits.included} credits)` : ''}`, { bold: true })}
                                            {this.aiBillingMetricRow('Current Cycle', period.end ? `Ends ${this.formatAiBillingDate(period.end)}` : 'No active cycle')}
                                            {this.aiBillingMetricRow('Credits Used', Number(credits.used) || 0, { bold: true })}
                                            {this.aiBillingMetricRow('Reserved', Number(credits.reserved) || 0)}
                                            {this.aiBillingMetricRow('Remaining', Number(credits.remaining) || 0, { color: '#16a46b', bold: true })}
                                            {this.aiBillingMetricRow('Top-Up Credits', `${Number(credits.topUpAvailable) || 0} (never expire)`, { bold: true })}
                                            <div style={{ height: 10, marginTop: 10, borderRadius: 10, background: '#ececf3', overflow: 'hidden' }}>
                                                <div style={{ width: `${ratio * 100}%`, minWidth: ratio > 0 ? 5 : 0, height: '100%', borderRadius: 10, background: '#e62117', transition: 'width 0.3s ease' }} />
                                            </div>
                                            <div style={{ marginTop: 16, paddingTop: 14, borderTop: '1px solid #e8eaf1', display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(210px, 1fr))', gap: 10 }}>
                                                <div>
                                                    <p className="m-0" style={{ color: '#172033', fontWeight: 700 }}>Charging policy</p>
                                                    <p className="m-0 mt-1" style={{ color: '#71819b', fontSize: 13 }}>
                                                        1 credit when a chat starts{summary.policy?.sequenceCheckpointEnabled ? `, then 1 every ${summary.policy.sequenceInterval} sequence messages` : ', with no sequence charge'}.
                                                    </p>
                                                </div>
                                                <div>
                                                    <p className="m-0" style={{ color: '#172033', fontWeight: 700 }}>Usage breakdown</p>
                                                    <p className="m-0 mt-1" style={{ color: '#71819b', fontSize: 13 }}>
                                                        {Number(summary.breakdown?.chatCreated) || 0} chat starts · {Number(summary.breakdown?.sequenceCheckpoints) || 0} sequence checkpoints
                                                    </p>
                                                </div>
                                            </div>
                                        </div>

                                        {checkPermission('admin.usersSubscriptions.edit') && (
                                            <div style={{ marginTop: 18, background: '#fff', border: '1px solid #e4e7ef', borderRadius: 16, padding: '20px 24px' }}>
                                                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', gap: 20, flexWrap: 'wrap' }}>
                                                    <div>
                                                        <p className="m-0" style={{ color: '#172033', fontSize: 16, fontWeight: 700 }}>Manual credit grant</p>
                                                        <p className="m-0 mt-1" style={{ color: '#71819b', fontSize: 13 }}>Every adjustment is audited in the immutable credit ledger.</p>
                                                    </div>
                                                </div>
                                                <div style={{ marginTop: 16, display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(180px, 1fr))', gap: 12 }}>
                                                    <div>
                                                        <label htmlFor="aiGrantCredits" style={{ display: 'block', color: '#506078', fontSize: 12, marginBottom: 6 }}>Credits</label>
                                                        <input
                                                            id="aiGrantCredits"
                                                            type="number"
                                                            min="1"
                                                            max="1000000"
                                                            step="1"
                                                            value={this.state.aiGrantCredits}
                                                            onChange={event => this.setState({ aiGrantCredits: event.target.value })}
                                                            placeholder="100"
                                                            style={{ width: '100%', height: 42, padding: '0 12px', border: '1px solid #dfe3eb', borderRadius: 9, color: '#172033' }}
                                                        />
                                                    </div>
                                                    <div>
                                                        <label htmlFor="aiGrantReason" style={{ display: 'block', color: '#506078', fontSize: 12, marginBottom: 6 }}>Reason</label>
                                                        <input
                                                            id="aiGrantReason"
                                                            type="text"
                                                            maxLength="500"
                                                            value={this.state.aiGrantReason}
                                                            onChange={event => this.setState({ aiGrantReason: event.target.value })}
                                                            placeholder="Service recovery, promotion, correction…"
                                                            style={{ width: '100%', height: 42, padding: '0 12px', border: '1px solid #dfe3eb', borderRadius: 9, color: '#172033' }}
                                                        />
                                                    </div>
                                                    <div>
                                                        <label htmlFor="aiGrantTicketRef" style={{ display: 'block', color: '#506078', fontSize: 12, marginBottom: 6 }}>Ticket reference (optional)</label>
                                                        <input
                                                            id="aiGrantTicketRef"
                                                            type="text"
                                                            maxLength="120"
                                                            value={this.state.aiGrantTicketRef}
                                                            onChange={event => this.setState({ aiGrantTicketRef: event.target.value })}
                                                            placeholder="SUP-1234"
                                                            style={{ width: '100%', height: 42, padding: '0 12px', border: '1px solid #dfe3eb', borderRadius: 9, color: '#172033' }}
                                                        />
                                                    </div>
                                                </div>
                                                <div style={{ marginTop: 14, display: 'flex', justifyContent: 'flex-end', gap: 10 }}>
                                                    <button
                                                        type="button"
                                                        disabled={this.state.aiBillingSubmitting}
                                                        onClick={this.clearAiGrantForm}
                                                        style={{ minWidth: 90, padding: '10px 18px', borderRadius: 22, color: '#506078', background: '#fff', border: '1px solid #dfe3eb', fontWeight: 600, opacity: this.state.aiBillingSubmitting ? 0.6 : 1 }}
                                                    >
                                                        Clear
                                                    </button>
                                                    <button
                                                        type="button"
                                                        disabled={this.state.aiBillingSubmitting}
                                                        onClick={this.submitAiCreditGrant}
                                                        style={{ minWidth: 150, padding: '10px 18px', borderRadius: 22, color: '#fff', background: '#20a878', fontWeight: 700, opacity: this.state.aiBillingSubmitting ? 0.6 : 1 }}
                                                    >
                                                        {this.state.aiBillingSubmitting ? 'Granting…' : 'Grant credits'}
                                                    </button>
                                                </div>
                                            </div>
                                        )}

                                        <div style={{ marginTop: 18, background: '#fff', border: '1px solid #e4e7ef', borderRadius: 16, overflow: 'hidden' }}>
                                            <div style={{ padding: '18px 22px', borderBottom: '1px solid #e8eaf1' }}>
                                                <p className="m-0" style={{ color: '#172033', fontSize: 16, fontWeight: 700 }}>Credit ledger</p>
                                                <p className="m-0 mt-1" style={{ color: '#71819b', fontSize: 13 }}>Latest charges, grants and adjustments for this tenant.</p>
                                            </div>
                                            <div style={{ overflowX: 'auto' }}>
                                                <table style={{ width: '100%', minWidth: 650, borderCollapse: 'collapse' }}>
                                                    <thead>
                                                        <tr style={{ color: '#71819b', background: '#fafbfc', fontSize: 12, textAlign: 'left' }}>
                                                            <th style={{ padding: '11px 18px', fontWeight: 600 }}>Date</th>
                                                            <th style={{ padding: '11px 18px', fontWeight: 600 }}>Event</th>
                                                            <th style={{ padding: '11px 18px', fontWeight: 600 }}>Reference</th>
                                                            <th style={{ padding: '11px 18px', fontWeight: 600, textAlign: 'right' }}>Credits</th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        {this.state.aiBillingLedger.map((item, index) => {
                                                            const delta = Number(item.deltaCredits) || 0
                                                            return (
                                                                <tr key={item.id || index} style={{ borderTop: '1px solid #edf0f4', color: '#344158', fontSize: 13 }}>
                                                                    <td style={{ padding: '12px 18px', whiteSpace: 'nowrap' }}>{this.formatAiBillingDate(item.createdAt)}</td>
                                                                    <td style={{ padding: '12px 18px' }}>{item.eventType || item.direction || 'Credit event'}</td>
                                                                    <td style={{ padding: '12px 18px', color: '#71819b' }}>{item.referenceId || item.metadata?.ticketRef || '—'}</td>
                                                                    <td style={{ padding: '12px 18px', textAlign: 'right', fontWeight: 700, color: delta >= 0 ? '#16a46b' : '#d64545' }}>
                                                                        {delta > 0 ? '+' : ''}{delta}
                                                                    </td>
                                                                </tr>
                                                            )
                                                        })}
                                                        {this.state.aiBillingLedger.length === 0 && (
                                                            <tr>
                                                                <td colSpan="4" style={{ padding: 30, color: '#8995a8', textAlign: 'center' }}>No credit events have been recorded yet.</td>
                                                            </tr>
                                                        )}
                                                    </tbody>
                                                </table>
                                            </div>
                                            {this.state.aiBillingNextCursor && (
                                                <div style={{ padding: '14px 20px', borderTop: '1px solid #edf0f4', textAlign: 'center' }}>
                                                    <button
                                                        type="button"
                                                        disabled={this.state.aiBillingLedgerLoadingMore}
                                                        onClick={this.loadMoreAiBillingLedger}
                                                        style={{ padding: '8px 16px', borderRadius: 18, color: '#506078', background: '#fff', border: '1px solid #dfe3eb', opacity: this.state.aiBillingLedgerLoadingMore ? 0.6 : 1 }}
                                                    >
                                                        {this.state.aiBillingLedgerLoadingMore ? 'Loading…' : 'Load more'}
                                                    </button>
                                                </div>
                                            )}
                                        </div>
                                    </div>
                                )
                            })()}
                        </div>
                    </Modal>
                    <Modal ref={el => this.extendTime = el} maxWidth={'30%'}>
                        {/* {console.log("propssssssss :  ",this.state.currentItem)} */}
                        {this.state.isChecked &&

                            <div className="w-100 " style={{ backgroundColor: '#fff', overflow: 'auto', borderRadius: 8 }}>
                                <div className="w-100" style={{ zIndex: 1, padding: '12px 22px', display: 'flex', justifyContent: 'space-between', alignItems: 'center', position: 'sticky', top: 0, borderBottom: '0px #eee solid', backgroundColor: '#f2f6f8ee', background: 'linear-gradient(to right,#d7e2f7dd,#dad6e4dd)', backdropFilter: 'blur(10px) saturate(180%)', WebkitBackdropFilter: 'blur(10px) saturate(180%)', borderRadius: '8px 8px 0px 0px' }}>
                                    <div>
                                        <p>Extend rental Time</p>

                                    </div>
                                    <div className="cursor-pointer" onClick={() => this.extendTime.hideModal()} style={{ width: 30, height: 30, borderRadius: '50%', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                                        <img style={{ width: 14, height: 14 }} src="/images/close.svg" alt="" />
                                    </div>

                                </div>
                                <div style={{ position: 'relative', padding: "2em", borderRadius: '10px', display: 'flex', flexDirection: 'column', justifyContent: 'space-around' }}>
                                    {this.state.notAvailable &&

                                        <p className="mb-2" style={{ fontSize: '1.1rem', fontWeight: 'bold', color: '#E32E2E' }}>
                                            your selected date is not available, please try another date
                                        </p>
                                    }

                                    {/* {<FormViewer changeValue={(k, e) => this.onChangeValueExtend(e)} ref={el => this.calenederInput = el} headers={this.state.headers}
                                        initData={this.props.initData} errors={this.state.errors} formClass={''} inputClass={'form-date'} />} */}

                                    {/* <p className="modern-input" style={{fontSize:'0.9rem',background:'#fff',boxShadow:'0 0 0', width:'85%',paddingBottom:0}}>New Date </p> */}
                                    <div>
                                        <label className='mb-2 mr-1 ml-1 required' style={{ marginBottom: 5, fontSize: 12, marginTop: 5, color: '#222' }}>New date</label>
                                        <div className="modern-input mt-1" style={{}}>

                                            <DateInput changeValue={(k, e) => this.onChangeValueExtend(e)} ref={el => this.calenederInput = el} header={{ label: "New date", key: 'extendTime', information: { label: "New date", required: true, placeholder: 'Select new date', inputClass: 'form-date' } }}
                                                initData={this.props.initData} errors={this.state.errors} formClass={''} />

                                        </div>

                                    </div>
                                    {/* <button onClick={() => this.setState({ isChecked: false, RecivedData: true })} style={{ background:'#677dc4',color:'#fff',padding: '0.8em 1em',borderRadius:'10px',fontSize:'1.2rem',fontWeight:550 }}> */}
                                    <button className="mt-3" onClick={() => this.sendExtendTimeReq()} style={{ background: '#677dc4', color: '#fff', padding: '0.8em 1em', borderRadius: '10px', fontSize: '1.2rem', fontWeight: 550 }}>

                                        Submit

                                    </button>

                                </div>


                            </div>

                        }
                        {this.state.RecivedData &&
                            <div className="calender-extendtime" style={{ borderRadius: '10px', background: '#fff', }}>
                                <div className="w-100" style={{ zIndex: 1, padding: '12px 22px', display: 'flex', justifyContent: 'space-between', alignItems: 'center', position: 'sticky', top: 0, borderBottom: '0px #eee solid', backgroundColor: '#f2f6f8ee', background: 'linear-gradient(to right,#d7e2f7dd,#dad6e4dd)', backdropFilter: 'blur(10px) saturate(180%)', WebkitBackdropFilter: 'blur(10px) saturate(180%)', borderRadius: '8px 8px 0px 0px' }}>
                                    <div>
                                        <p>Extend rental Time</p>

                                    </div>
                                    <div className="cursor-pointer" onClick={() => this.extendTime.hideModal()} style={{ width: 30, height: 30, borderRadius: '50%', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                                        <img style={{ width: 14, height: 14 }} src="/images/close.svg" alt="" />
                                    </div>

                                </div>
                                <div style={{ position: 'relative', background: '#fff', padding: "2em", borderRadius: '10px', display: 'grid', justifyItems: 'center', alignContent: 'space-around' }}>

                                    <p style={{ fontSize: '1.1rem', fontWeight: '600', color: '#686E7C', }}>
                                        Your Selected date is available
                                    </p>
                                    <div style={{ display: 'flex', alignItems: 'center' }}>
                                        <div style={{ padding: '1.3em' }}>
                                            <p className="modern-input" style={{ padding: '0.7em', marginBottom: '10px', display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                                                <a style={{ fontSize: '0.8rem' }}>Your new end date is </a><br /><a style={{ fontWeight: 600, borderBottom: '1px solid gray', fontSize: '0.9rem' }}> {moment(this.state.extendTime).tz('Asia/Singapore').startOf('day').format('YYYY - MMM - DD')}</a>
                                            </p>
                                            <p className="modern-input" style={{ padding: '0.7em', display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                                                <a style={{ fontSize: '0.8rem' }}>And your extra payment is </a><br /><a style={{ fontWeight: 600, borderBottom: '1px solid gray', fontSize: '0.9rem' }}> S$ {this.state.extendPrice}</a>
                                            </p>
                                        </div>
                                    </div>
                                    <button onClick={() => this.sendExtendTimeReq(true)} style={{ background: '#677dc4', color: '#fff', padding: '0.8em 1em', borderRadius: '10px', width: '80%', fontSize: '1.2rem', fontWeight: 550 }}>

                                        Done

                                    </button>
                                </div>

                            </div>
                        }
                        {!this.state.RecivedData && !this.state.isChecked &&
                            <div className="calender-extendtime" style={{ position: 'relative', background: '#fff', padding: "2em", borderRadius: '10px', height: '30vh', display: 'grid', justifyItems: 'center', alignContent: 'space-around' }}>

                                <div className="py-4 px-3 pb-2 w-100 text-center">
                                    <Loader
                                        type="Oval"
                                        color="#789"
                                        height="50"
                                        width="50"
                                    />
                                    <p>We are checking the availablity ...</p>
                                    <p className="text-smaller" style={{ color: '#789' }}>Wait till it is completed</p>

                                </div>

                            </div>
                        }

                    </Modal>
                    <Modal ref={el => this.dedidatePlanModal = el} maxWidth={'320px'}>
                        {/* {console.log("propssssssss :  ",this.state.currentItem)} */}

                        <div className="calender-extendtime" style={{ borderRadius: '10px', background: '#fff', }}>
                            <div className="w-100" style={{ zIndex: 1, padding: '12px 22px', display: 'flex', justifyContent: 'space-between', alignItems: 'center', position: 'sticky', top: 0, borderBottom: '0px #eee solid', backgroundColor: '#f2f6f8ee', background: 'linear-gradient(to right,#d7e2f7dd,#dad6e4dd)', backdropFilter: 'blur(10px) saturate(180%)', WebkitBackdropFilter: 'blur(10px) saturate(180%)', borderRadius: '8px 8px 0px 0px' }}>
                                <div>
                                    {this.state.sentPaymentLink ? (

                                        <p>Dedicate plan and send payment link</p>
                                    ) : (
                                        <p>Dedicate plan</p>

                                    )}

                                </div>
                                <div className="cursor-pointer" onClick={() => this.dedidatePlanModal.hideModal()} style={{ width: 30, height: 30, borderRadius: '50%', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                                    <img style={{ width: 14, height: 14 }} src="/images/close.svg" alt="" />
                                </div>

                            </div>
                            <div style={{ position: 'relative', background: '#fff', padding: "2em", borderRadius: '10px', display: 'grid', justifyItems: 'center', alignContent: 'space-around' }}>

                                <div className="row m-0" style={{ display: 'flex', alignItems: 'center', minWidth: 170 }}>
                                    <p>Plan</p>
                                    <div className="modern-input mb-3 mt-1 w-100" style={{ minWidth: 250 }}>
                                        <AdvancedSelectInput changeValue={(k, e) => this.onChangeValuePlan(e, 'subscriptionPlan')} data={this.state.subscriptionPlan} ref={el => this.calenederInput = el} header={{ label: 'Plan', key: 'plan', type: 'SelectInput', col: '12', information: { isSearchable: true, label: 'Plan', type: 'api', fields: { value: '_id', title: 'name', description: 'description' }, address: 'getSubscriptionPlans', filter: {} }, settings: {}, showMain: true, showInfilter: true, inExport: true }}
                                            initData={{}} errors={this.state.errors} formClass={''} />

                                    </div>
                                    {/* {this.state.sentPaymentLink && (

                                        <>
                                            <p>Trial Days</p>

                                            <div className="modern-input mt-1 pb-3" style={{}}>

                                                <NumberInput changeValue={(k, e) => this.onChangeValuePlan(e, 'trialDays')} ref={el => this.calenederInput = el} header={{ label: 'Trial Days', type: 'NumberInput', key: 'MarketplaceLisitng', col: '6', information: { label: 'Trial Days', }, showMain: true }}
                                                    initData={{}} data={this.state.trialDays} errors={this.state.errors} formClass={''} />

                                            </div>
                                        </>
                                    )} */}
                                </div>
                                {this.state.sentPaymentLink ? (

                                    <button className=" mt-3" onClick={() => this.sendDedicatePlanReqWithLink()} style={{ background: '#677dc4', color: '#fff', padding: '0.8em 1em', borderRadius: '10px', width: '80%', fontSize: '1.2rem', fontWeight: 550 }}>

                                        Done

                                    </button>) : (
                                    <button className=" mt-3" onClick={() => this.sendDedicatePlanReq()} style={{ background: '#677dc4', color: '#fff', padding: '0.8em 1em', borderRadius: '10px', width: '80%', fontSize: '1.2rem', fontWeight: 550 }}>

                                        Done

                                    </button>

                                )}

                            </div>

                        </div>



                    </Modal>
                </div>
            </Configurer >
        )
    }


}



const mapStateToProps = state => ({ settings: state.settings, user: state.user })
const mapDispatchToProps = dispatch => ({ actions: bindActionCreators(actions, dispatch) })

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(AdminFormApplet);
